<template>
<div>
  <div v-if="currentstep == 22">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-right resume-builder-choose">
          <div class="content">
            <h3>Do you want to personalize your resume?</h3>
            <h4 class="text-center">Do you have a job description?</h4>
            <div class="resume-build personalize-resume">
              <a
                href="javascript:void(0);"
                @click.prevent="haveJobdesc('yes')"
                class="resume-block first-box"
              >
                <span class="checkmark-active">
                  <i class="material-icons">done</i>
                </span>
                <h4>Yes</h4>
                <!-- <p>We will help to customize your resume</p> -->
              </a>
              <div>
                <a
                  href="javascript:void(0);"
                  @click.prevent="haveJobdesc('no')"
                  class="resume-block second-box"
                >
                  <span class="checkmark-active">
                    <i class="material-icons">done</i>
                  </span>
                  <h4>No</h4>
                  <!-- <p>We will transfer everything to your new template</p> -->
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 21">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>

      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li
                data-aos="active aos-init aos-animate"
                data-aos-duration="1000"
                class="active aos-init"
              >
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <div class="jd-job-desc enter-jd-job">
            <div class="job-desc">
              <h4>
                Enter Job Description
                <span class="required">*</span>
              </h4>
              <textarea v-model="Job_desc"></textarea>
              <span
                v-if="err_jd"
                style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
              >Enter valid job description</span>
            </div>
          </div>
          <div class="btn-sec">
            <a
              href="javascript:void(0);"
              @click.prevent="backfromjd('custom')"
              class="btn-secondary md-ink-ripple"
            >Back</a>
            <a
              href="javascript:void(0);"
              @click.prevent="submittocustomize"
              class="btn-primary md-ink-ripple"
            >Personalize</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 23">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
    </body>
    <div class="resume-builder-main">
      <div class="resume-builder-left">
        <div class="resume-section">
          <h3>Resume Sections</h3>
          <div class="logo">
            <a href="/Dashboard">
              <img src="/img/CC-Logo-White.1144d714.svg" alt>
            </a>
          </div>
          <ul>
            <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
              <a @click.prevent="Jumptoheading">
                <span>1</span> Heading
              </a>
            </li>
            <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
              <a @click.prevent="Jumptowork">
                <span>2</span> Experience
              </a>
            </li>
            <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
              <a @click.prevent="Jumptoeducation" href>
                <span>3</span> Education
              </a>
            </li>
            <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
              <a @click.prevent="Jumptoskill" href>
                <span>4</span> Skills
              </a>
            </li>
            <li
              data-aos="active aos-init aos-animate"
              data-aos-duration="1000"
              class="active aos-init"
            >
              <a @click.prevent="Jumptosummary" href>
                <span>5</span>Summary
              </a>
            </li>
            <li data-aos="fade-up" data-aos-duration="1200" class="active aos-init">
              <a @click.prevent="Jumptooptional" href>
                <span>6</span> Others
              </a>
            </li>
            <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
              <a @click.prevent="Jumptofinal" href>
                <span>7</span> Finalize
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="resume-builder-right">
        <div class="jd-job-desc enter-jd-job">
          <div class="job-desc">
            <h4>
              Enter Job Description
              <span class="required">*</span>
            </h4>
            <textarea v-model="Job_desc"></textarea>
            <span
              v-if="err_jd"
              style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
            >Enter valid job description</span>
          </div>
        </div>
        <div class="btn-sec">
          <a
            href="javascript:void(0);"
            @click.prevent="backfromjd('match')"
            class="btn-secondary md-ink-ripple"
          >Back</a>
          <a
            href="javascript:void(0);"
            @click.prevent="submittomatch"
            class="btn-primary md-ink-ripple"
          >Calculate Match</a>
        </div>
      </div>
    </div>
  </div>

  <div v-if="currentstep == 24">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-right resume-builder-choose">
          <div class="content profile-match">
            <p>
              Percentage match: {{ match_percentage }}
              <span v-if="perfectmatch">%</span>
            </p>
            <div class="resume-build">
              <br>
              <p>Reason: {{ Reason }}</p>
            </div>
          </div>

          <div :style="{'justify-content:flex-end':allow_custom_cv}" class="btn-sec">
            <a @click.prevent="goback()" class="btn-secondary md-ink-ripple">Back</a>
            <a
              href="#"
              v-if="allow_custom_cv"
              :class="{ 'global-disabled': !perfectmatch }"
              @click.prevent="DirectGeneration"
              class="btn-primary md-ink-ripple"
            >Personalize</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <div v-if="currentstep == 1">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1000" class="aos-init">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content">
            <h3>Resume Heading</h3>
            <div class="form-section">
              <div class="left-form">
                <div class="headingSection">
                  <div class="uploadSection">
                    <div class="upload-img">
                      <div class="img-box">
                        <img id="imgPreview" :src="temp_pic" alt>
                      </div>
                      <label class="btn-secondary md-ink-ripple" for="fileUpload">Upload Image</label>
                      <input
                        style="display: none;"
                        type="file"
                        name="fileUpload"
                        @change="previewFiles"
                        id="fileUpload"
                        accept="image/*"
                      >
                    </div>
                  </div>

                  <div class="headingContent">
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>
                            First Name
                            <span class="required">*</span>
                          </label>
                          <input
                            class="form-control"
                            v-model="First_Name"
                            type="text"
                            @input="err_name = false;showselectedcv()"
                            v-on:keypress="validateKeyPress(event)"
                            name
                            placeholder="e.g. Rahul"
                          >
                        </div>
                        <span
                          v-if="err_name"
                          style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                        >Enter valid first name</span>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>Surname</label>
                          <input
                            class="form-control"
                            type="text"
                            @input="showselectedcv()"
                            v-on:keypress="validateKeyPress(event)"
                            v-model="Last_Name"
                            name
                            placeholder="e.g. Sharma"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>
                            Profession
                            <span class="required">*</span>
                          </label>
                          <input
                            class="form-control"
                            type="text"
                            v-on:keypress="validateKeyPress(event)"
                            v-model="Profession"
                            @input="err_prof = false;showselectedcv()"
                            name
                            placeholder="e.g. Software Engineer"
                          >
                        </div>
                        <span
                          v-if="err_prof"
                          style="
                          color: red;
                          margin-top: 0px;
                          margin-bottom: 7px;
                          display: block;
                        "
                        >Enter valid profession</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label>Pincode</label>
                          <input
                            class="form-control"
                            type="number"
                            v-on:keypress="isPincode(event)"
                            v-model="Pin_code"
                            @input="populatecitycountry"
                            name
                            placeholder="302006"
                          >
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <div class="form-group">
                          <label>Country</label>
                          <input
                            class="form-control"
                            type="text"
                            v-model="Country"
                            @input="showselectedcv()"
                            name
                            placeholder="India"
                          >
                        </div>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>City</label>
                          <!-- <input
                        class="form-control"
                        v-model="City"
                        type="text"
                        name
                        placeholder="Jaipur"
                          >-->
                          <multiselect
                            v-model="City"
                            :options="cities"
                            :taggable="true"
                            @tag="onTagcity($event)"
                            :multiple="false"
                          ></multiselect>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>Phone</label>
                          <input
                            class="form-control"
                            type="number"
                            v-on:keypress="isNumber(event)"
                            v-model="Phone"
                            name
                            @input="err_phone = false;showselectedcv()"
                            placeholder="e.g. 9876543210"
                          >
                        </div>
                        <span
                          v-if="err_phone"
                          style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                        >Enter valid phone number</span>
                      </div>
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>
                            Email
                            <span class="required">*</span>
                          </label>
                          <input
                            class="form-control"
                            type="email"
                            name
                            @input="EmailCheck;showselectedcv()"
                            v-model="Email"
                            placeholder="e.g. sharma@gmail.com"
                          >
                        </div>
                        <span
                          v-if="err_email_regex"
                          style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                        >Enter valid email address</span>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group">
                          <label>Address</label>
                          <input
                            class="form-control"
                            type="text"
                            name
                            v-model="Address"
                            @input="showselectedcv()"
                            placeholder
                          >
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <div>
                          <a @click="AddSociallink" class="add-social-links add">
                            <span v-if="issocial">
                              <i class="material-icons">add</i>Add Social Link(Optional)
                            </span>
                            <span v-if="!issocial">
                              <i class="material-icons">remove</i>Minimize
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div v-if="!issocial">
                      <div class="row">
                        <div class="col-xl-6">
                          <div class="form-group">
                            <label>LinkedIn</label>
                            <input
                              class="form-control"
                              type="text"
                              v-model="Linkedin"
                              @input="showselectedcv()"
                              name
                              placeholder
                            >
                          </div>
                        </div>
                        <div class="col-xl-6">
                          <div class="form-group">
                            <label>Twitter</label>
                            <input
                              class="form-control"
                              type="text"
                              v-model="Twitter"
                              @input="showselectedcv()"
                              name
                              placeholder
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-xl-6">
                          <div class="form-group">
                            <label>Website</label>
                            <input
                              class="form-control"
                              type="text"
                              v-model="Website"
                              @input="showselectedcv()"
                              name
                              placeholder
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <!-- <div class="template-preview">
                  <img src="../../assets/view-resume.jpg" alt>
                  <img class="shadow" src="../../assets/transparent-black.png" alt>
                  <div class="btns">
                    <a href="#" class="btn-primary md-ink-ripple preview" @click.prevent="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>
                    <select v-model="template_name" @change="showselectedcv" class="form-control">
                      <option value="resume1.png">Template 1</option>
                      <option value="resume2.png">Template 2</option>
                      <option value="resume3.png">Template 3</option>
                      <option value="resume4.png">Template 4</option>
                    </select>
                  </div>
                </div>-->
                <div class="template-preview">
                  <div class="resume-template">
                    <div v-if="showResume">
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    <div v-if="showResumetwo">
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    <div v-if="showResumethree">
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    <div v-if="showResumefour">
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    <div v-if="showResumefive">
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    <div v-if="showResumesix">
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    <div v-if="showResumeseven">
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    <div v-if="showResumeeight">
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    <div v-if="showResumenine">
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    <div v-if="showResumetwelve">
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                  </div>
                  <div class="btn-select-template">
                    <a href="#" class="primary-btn preview" @click="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>

                    <a class="TemplateBtn" @click.prevent="Changetemplateprompt" data-toggle="modal" data-target="#ChnageTemplate">
                      <img src="../../assets/template.png" alt>
                      <span>
                        Change Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="justify-content:flex-end;" class="btn-sec">
            <a
              href="javascript:void(0);"
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Next : Experience</a>
          </div>
        </div>
      </div>

      <!-- Optional JavaScript -->
      <!-- jQuery first, then Popper.js, then Bootstrap JS -->
    </div>
    <div v-if="opencarousel" class="choose-template-sec">
      <span @click.prevent="opencarousel=false" class="material-icons popupclose">close</span>
      <carousel :items="5" v-if="opencarousel">
        <div
          @click.prevent="Handlecarousel(item)"
          v-for="(item, index) in cvTemplates"
          :key="index"
        >
          <img :src="item.img" :alt="item.name">
        </div>
      </carousel>
    </div>
  </div>
  <div v-if="currentstep == 2">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1000" class="aos-init">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content">
            <h3>Tell us about your most recent job</h3>
            <p>We'll start there and work backward</p>
            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div>
                        <!-- <input
                          v-model="filterName"
                          placeholder="Search..."
                          @input="GetJobTitle(filterName)"
                          class="form-control"
                        >
                        <select v-model="Job_Title" class="form-control">
                          <option
                            v-for="option in jobtitlelist"
                            :key="option"
                            :value="option"
                          >{{ option }}</option>
                        </select>-->
                        <multiselect
                          v-model="Job_Title"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Employer</label>
                      <input
                        class="form-control"
                        v-model="Employer"
                        type="text"
                        @input="showselectedcv()"
                        v-on:keypress="validateKeyPress(event)"
                        name
                        placeholder="e.g. H & M"
                      >
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>City</label>
                      <!-- <input
                        class="form-control"
                        type="text"
                        v-model="Work_City"
                        name
                        placeholder="Jaipur"
                      >-->
                      <v-autocomplete
                        ref="geoLocation_autocomplete"
                        placeholder="City"
                        id="citywork"
                        name="location name"
                        data-vv-delay="300"
                        :auto-select-one-item="false"
                        :items="customers"
                        v-model="customer"
                        :get-label="getLabel"
                        :component-item="template"
                        @update-items="updateItems"
                        @item-selected="location_selected"
                      ></v-autocomplete>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Country</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="Work_Country"
                        @input="showselectedcv()"
                        name
                        placeholder="India"
                      >
                    </div>
                  </div>
                </div>
                <div v-if="mmyyyy" class="row">
                  <div>
                    <div class="form-group datepickerhold flatpickr" id="div_from_date_id">
                      <label>Start Date</label>
                      <input
                        id="start_date_id"
                        v-model="Start_Date"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                      >{{ start_date_message }}</span>
                    </div>
                  </div>
                  <div>
                    <div
                      class="form-group datepickerhold flatpickr"
                      v-bind:class="{ 'global-disabled': currentwork }"
                      id="div_end_date_id"
                    >
                      <label>End Date</label>
                      <input
                        id="end_date_id"
                        v-model="End_Date"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >

                      <span class="date-field-in"></span>
                      <span
                        style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                      >{{ end_date_message }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div>
                    <div class="form-group datepickerhold flatpickr" id="div_from_date_id">
                      <label>Start Date</label>
                      <input
                        id="start_date_id"
                        v-model="Start_Date"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                      >{{ start_date_message }}</span>
                    </div>
                  </div>
                  <div>
                    <div
                      class="form-group datepickerhold flatpickr"
                      v-bind:class="{ 'global-disabled': currentwork }"
                      id="div_end_date_id"
                    >
                      <label>End Date</label>
                      <input
                        id="end_date_id"
                        v-model="End_Date"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >

                      <span class="date-field-in"></span>
                      <span
                        style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                      >{{ end_date_message }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="mmyyyy">
                    Date in MM/YYYY
                  </label>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" v-model="currentwork" class="form-check-input" value>
                    I currently work here
                  </label>
                </div>
              </div>
              <div class="right-form">
                <div class="template-preview">
                  <div class="resume-template">
                    <div v-if="showResume">
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    <div v-if="showResumetwo">
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    <div v-if="showResumethree">
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    <div v-if="showResumefour">
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    <div v-if="showResumefive">
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    <div v-if="showResumesix">
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    <div v-if="showResumeseven">
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    <div v-if="showResumeeight">
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    <div v-if="showResumenine">
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    <div v-if="showResumetwelve">
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                  </div>
                  <div class="btn-select-template">
                    <a href="#" class="primary-btn preview" @click="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>

                    <a @click.prevent="Changetemplateprompt" data-toggle="modal" data-target="#ChnageTemplate" class="TemplateBtn">
                      <img src="../../assets/template.png" alt>
                      <span>
                        Change Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </div>
                </div>
                <!-- <div class="template-preview">
                  <img src="../../assets/view-resume.jpg" alt>
                  <img class="shadow" src="../../assets/transparent-black.png" alt>
                  <div class="btns">
                    <a class="btn-primary md-ink-ripple preview" @click.prevent="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>
                    <select v-model="template_name" @change="showselectedcv" class="form-control">
                      <option value="resume1.png">Template 1</option>
                      <option value="resume2.png">Template 2</option>
                      <option value="resume3.png">Template 3</option>
                      <option value="resume4.png">Template 4</option>
                    </select>
                  </div>
                </div>-->
              </div>
            </div>
          </div>

          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Save & Continue</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="opencarousel" class="choose-template-sec">
      <span @click.prevent="opencarousel=false" class="material-icons popupclose">close</span>
      <carousel :items="5" v-if="opencarousel">
        <div
          @click.prevent="Handlecarousel(item)"
          v-for="(item, index) in cvTemplates"
          :key="index"
        >
          <img :src="item.img" :alt="item.name">
        </div>
      </carousel>
    </div>
  </div>
  <div v-if="currentstep == 3">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1000" class="aos-init">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Work Description</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job title</label>
                      <div class="search">
                        <!-- <input class="form-control" type="text" name="" placeholder="Job Title" />
                        <button class="search-btn"><img src="../../assets/search-white.png" alt="" /></button>-->
                        <multiselect
                          v-model="filterName"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular Search
                      </h6>
                      <ul>
                        <li>
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="(data, index) in WorkDesc" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click.prevent="addworkdesc(data)">
                            <i v-if="!description.includes(data)" class="fa fa-plus"></i>
                            <i v-if="description.includes(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div >
                  <h5 class="ckeditor-heading" v-if="description!=''">Work description Added</h5>
                  <div class="box">
                    <ckeditor v-model="description" :editor="editor"></ckeditor>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              href="#"
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Save & Continue</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 4">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1000" class="aos-init">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <div class="content">
            <h3>Work</h3>

            <div class="form-section">
              <div class="left-form">
                <div v-for="(item, index) in work" class="details-fill-box">
                  <div class="fill-box-button">
                    <a class="edit-icon" data-toggle="tooltip" data-placement="top" title="Edit" @click.prevent="editworkv1(index, item)">
                      <i class="material-icons">edit</i>
                    </a>

                    <a class="delete-icon" data-toggle="tooltip" data-placement="top" title="Delete" @click.prevent="removeWork(index)">
                      <i class="material-icons">delete</i>
                    </a>
                  </div>
                  <div>
                    <strong>Job Title:</strong>
                    {{ item.jobtitle }}
                  </div>
                  <div>
                    <strong>Employer:</strong>
                    {{ item.employer }}
                  </div>
                  <div>
                    <strong>Start Date:</strong>
                    {{ item.startdate }}
                  </div>
                  <div>
                    <strong>End Date:</strong>
                    {{ item.enddate }}
                  </div>
                  <div>
                    <strong>Description:</strong>
                    <div v-html="item.description"></div>
                  </div>
                  <div>
                    <strong>City:</strong>
                    {{ item.city }}
                  </div>
                  <div>
                    <strong>Country:</strong>
                    {{ item.country }}
                  </div>
                  <hr>
                </div>

                <div class="resume-btn-sec">
                  <a class="btn-primary md-ink-ripple" @click.prevent="Addnew">
                    <i class="fa fa-plus"></i> Add New Experience
                  </a>
                  <a
                    v-if="work.length>0"
                    class="btn-primary md-ink-ripple"
                    @click="ReverseWork"
                  >Reverse</a>
                </div>
              </div>
              <div class="right-form"></div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Next : Education</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 5">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1000" class="aos-init">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content">
            <h3>Tell us about your education</h3>
            <p>Include every school, even if you're still there on didn't graduate.</p>
            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>School Name</label>
                      <input
                        class="form-control"
                        type="text"
                        v-on:keypress="validateKeyPress(event)"
                        @input="showselectedcv()"
                        name
                        v-model="School_name"
                        placeholder="e.g. Oxford Software Institute"
                      >
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>School Location</label>
                      <!-- <input
                        class="form-control"
                        type="text"
                        v-model="School_loc"
                        name
                        placeholder="e.g. New Delhi, India"
                      >-->
                      <v-autocomplete
                        ref="geoLocationEd_autocomplete"
                        placeholder="City"
                        name="location name"
                        data-vv-delay="300"
                        :auto-select-one-item="false"
                        :items="customers"
                        v-model="customer_ed"
                        :get-label="getLabel"
                        :component-item="template"
                        @update-items="updateItems"
                        @item-selected="location_ED_selected"
                      ></v-autocomplete>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Degree</label>
                      <input
                        class="form-control"
                        type="text"
                        v-model="School_degree"
                        name
                        @input="showselectedcv()"
                        placeholder="e.g. BCA"
                      >
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <label>Field of Study</label>
                      <input
                        class="form-control"
                        v-model="Field_study"
                        type="text"
                        v-on:keypress="validateKeyPress(event)"
                        name
                        @input="showselectedcv()"
                        placeholder="e.g. Financial Accounting"
                      >
                    </div>
                  </div>
                </div>
                <div v-if="grad_mmyyyy" class="row">
                  <div>
                    <div class="form-group datepickerhold flatpickr" id="div_gradfrom_date_id">
                      <label>Start Date</label>
                      <input
                        id="gradstart_date_id"
                        v-model="Grad_startdate"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                      >{{ start_date_message }}</span>
                    </div>
                  </div>
                  <div>
                    <div
                      class="form-group datepickerhold flatpickr"
                      v-bind:class="{ 'global-disabled': currentstudy }"
                      id="div_gradend_date_id"
                    >
                      <label>End Date</label>
                      <input
                        id="gradend_date_id"
                        v-model="Grad_Enddate"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                      >{{ end_date_message }}</span>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div>
                    <div class="form-group datepickerhold flatpickr" id="div_gradfrom_date_id">
                      <label>Start Date</label>
                      <input
                        id="gradstart_date_id"
                        v-model="Grad_startdate"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                      >{{ start_date_message }}</span>
                    </div>
                  </div>
                  <div>
                    <div
                      class="form-group datepickerhold flatpickr"
                      v-bind:class="{ 'global-disabled': currentstudy }"
                      id="div_gradend_date_id"
                    >
                      <label>End Date</label>
                      <input
                        id="gradend_date_id"
                        v-model="Grad_Enddate"
                        class="form-control start_date"
                        data-input
                        tabindex="0"
                        type="text"
                        autocomplete="off"
                      >
                      <span class="date-field-in"></span>
                      <span
                        style="
                      color: red;
                      margin-top: 0px;
                      margin-bottom: 7px;
                      display: block;
                    "
                      >{{ end_date_message }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="grad_mmyyyy">
                    Date in MM/YYYY
                  </label>
                </div>

                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-check">
                      <label class="form-check-label">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          v-model="currentstudy"
                          value
                        >
                        I currently attend here
                      </label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div>
                      <a @click.prevent="AddEddesc" class="add-social-links add">
                        <span v-if="isEddesc">
                          <i class="material-icons">add</i> Add a description to this section
                        </span>
                        <span v-if="!isEddesc">
                          <i class="material-icons">remove</i> Add a description to this section
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="input-container" v-if="!isEddesc" style="display: block;">
                  <div>
                    <div class="job-description-container mb-4 mt-2">
                      <label for="descriptionDropdown">Add description:</label>
                      <select
                        class="form-control"
                        id="descriptionDropdown"
                        @change="addeddescs"
                        v-model="Schooldesc"
                      >
                        <option disabled selected>Select a description</option>
                        <option value="Awarded [Award Name]">Awarded [Award Name]</option>
                        <option
                          value="Elected to [Elected Position] for [Student Organization, Fraternity or Sorority] in [Year]"
                        >Elected to [Elected Position] for [Student Organization, Fraternity or Sorority] in [Year]</option>
                        <option value="Completed professional development in [Subject]">
                          Completed professional development
                          in [Subject]
                        </option>
                        <option
                          value="Member of [Fraternity or Sorority Name]"
                        >Member of [Fraternity or Sorority Name]</option>
                        <option
                          value="Continuing education in [Subject]"
                        >Continuing education in [Subject]</option>
                        <option value="Member of [Student Organization or Club Name]">
                          Member of [Student Organization or
                          Club Name]
                        </option>
                        <option value="Received [Scholarship Name]">Received [Scholarship Name]</option>
                        <option value="Professional development completed in [Subject]">
                          Professional development completed
                          in [Subject]
                        </option>
                        <option
                          value="Dean List [Semester and Year]"
                        >Dean's List [Semester and Year]</option>
                        <option
                          value="Member of [Honors Society Name]"
                        >Member of [Honor's Society Name]</option>
                        <option value="Elected Captain of [Team]">Elected Captain of [Team]</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <div class="editor-container">
                      <ckeditor v-model="School_desc" :editor="editor"></ckeditor>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div class="template-preview">
                  <div class="resume-template">
                    <div v-if="showResume">
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    <div v-if="showResumetwo">
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    <div v-if="showResumethree">
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    <div v-if="showResumefour">
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    <div v-if="showResumefive">
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    <div v-if="showResumesix">
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    <div v-if="showResumeseven">
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    <div v-if="showResumeeight">
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    <div v-if="showResumenine">
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    <div v-if="showResumetwelve">
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                  </div>
                  <div class="btn-select-template">
                    <a href="#" class="primary-btn preview" @click="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>
                    <a @click.prevent="Changetemplateprompt" data-toggle="modal" data-target="#ChnageTemplate" class="TemplateBtn">
                      <img src="../../assets/template.png" alt>
                      <span>
                        Change Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </div>
                </div>
                <!-- <div class="template-preview">
                  <img src="../../assets/view-resume.jpg" alt>
                  <img class="shadow" src="../../assets/transparent-black.png" alt>

                  <div class="btns">
                    <a @click.prevent="previewResumeone" class="btn-primary md-ink-ripple preview">
                      <i class="material-icons">visibility</i> Preview
                    </a>
                    <select v-model="template_name" @change="showselectedcv" class="form-control">
                      <option value="resume1.png">Template 1</option>
                      <option value="resume2.png">Template 2</option>
                      <option value="resume3.png">Template 3</option>
                      <option value="resume4.png">Template 4</option>
                    </select>
                  </div>
                </div>-->
              </div>
            </div>
          </div>

          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Save & Continue</a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="opencarousel" class="choose-template-sec">
      <span @click.prevent="opencarousel=false" class="material-icons popupclose">close</span>
      <carousel :items="5" v-if="opencarousel">
        <div
          @click.prevent="Handlecarousel(item)"
          v-for="(item, index) in cvTemplates"
          :key="index"
        >
          <img :src="item.img" :alt="item.name">
        </div>
      </carousel>
    </div>
  </div>
  <div v-if="currentstep == 6">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1000" class="aos-init">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <div class="content">
            <h3>Tell us about your education</h3>
            <p>Include every school, even if you're still there on didn't graduate.</p>
            <div class="form-section">
              <div class="left-form">
                <div v-for="(item, index) in Education" class="details-fill-box">
                  <div class="fill-box-button">
                    <a data-toggle="tooltip" data-placement="top" title="Edit" class="edit-icon" @click.prevent="editeducationv1(index, item)">
                      <i class="material-icons" >edit</i>
                    </a>

                    <a class="delete-icon" data-toggle="tooltip" data-placement="top" title="Delete" @click.prevent="removeEducation(index)">
                      <i class="material-icons">delete</i>
                    </a>
                  </div>
                  <div>
                    <strong>Field of study:</strong>
                    {{ item.field }}
                  </div>

                  <div>
                    <strong>Degree:</strong>
                    {{ item.degree }}
                  </div>

                  <div>
                    <strong>Description:</strong>
                    <div v-html="item.description"></div>
                  </div>

                  <div>
                    <strong>School Name:</strong>
                    {{ item.school_name }}
                  </div>

                  <div>
                    <strong>School Location:</strong>
                    {{ item.school_location }}
                  </div>

                  <div>
                    <strong>Start Date:</strong>
                    {{ item.grad_startdate }}
                  </div>
                  <div>
                    <strong>End Date:</strong>
                    {{ item.grad_enddate }}
                  </div>

                  <hr>
                </div>

                <div class="resume-btn-sec">
                  <a class="btn-primary md-ink-ripple" @click.prevent="AddnewEd">
                    <i class="fa fa-plus"></i> Add New Education
                  </a>
                </div>
              </div>
              <div class="right-form"></div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Next : Skills</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 7">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1000" class="aos-init">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Skills</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div class="search">
                        <multiselect
                          v-model="filterName"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular Search
                      </h6>
                      <ul>
                        <li class="active">
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="data in Skill_list" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click.prevent="Addskill(data)">
                            <i v-if="!skillrepeat(data)" class="fa fa-plus"></i>
                            <i v-if="skillrepeat(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div class="skill-add-sec">
                  <h5 v-if="skill.length>0">Skills Added</h5>
                  <div v-for="(data, index) in skill" class="box">
                    <input
                      class="form-control"
                      type="text"
                      v-model="data.text"
                      @input="showselectedcv"
                      name
                      placeholder="e.g. Hobbies"
                    >
                    <div class="star-rating">
                      <span
                        v-for="rating in ratings"
                        :key="rating"
                        @click="setRating(rating,data)"
                        :class="{ 'selected': rating <= data.rate }"
                      >
                        &#9733;
                        <!-- Unicode star character -->
                      </span>
                    </div>
                    <a class="delete-icon" @click="removeskill(index)">
                      <i class="material-icons">delete</i>
                    </a>
                  </div>
                  <a
                    href="javascript:void(0);"
                    v-if="skill.length>0"
                    class="btn-primary md-ink-ripple mt-3"
                    @click="addmoreskill()"
                  >
                    <i class="fa fa-plus"></i> Add more
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Next : Summary</a>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
  <div v-if="currentstep == 8">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li
                data-aos="active aos-init aos-animate"
                data-aos-duration="1000"
                class="active aos-init"
              >
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Summary</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div class="search">
                        <multiselect
                          v-model="filterName"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular Search
                      </h6>
                      <ul>
                        <li class="active">
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="data in Summary_list" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click.prevent="Addsummary(data)">
                            <i v-if="!summary.includes(data)" class="fa fa-plus"></i>
                            <i v-if="summary.includes(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div>
                  <h5
                   class="ckeditor-heading"
                    v-if="summary!=''"
                  >Summary Added</h5>
                  <div style="margin-top: 15px;" class="box">
                    <ckeditor v-model="summary" :editor="editor"></ckeditor>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Next : Others</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 9">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1000">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content" data-aos="fade-up" data-aos-duration="800">
            <p>These sections are optional.</p>
            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-6 checkbox-sec">
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="isaccomplishment">
                      <label for="flexCheckDefault">Accomplishments</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="isaffilation">
                      <label for="flexCheckDefault">Affiliations</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="isadditional">
                      <label for="flexCheckDefault">Additional Information</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="issoftware">
                      <label for="flexCheckDefault">Software</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="islang">
                      <label for="flexCheckDefault">Languages</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="iscertificate">
                      <label for="flexCheckDefault">Certifications</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value id="flexCheckDefault" v-model="isintrest">
                      <label for="flexCheckDefault">Interests</label>
                    </div>
                    <div class="form-check">
                      <input type="checkbox" value v-model="isown">
                      <label>Add Your Own</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="add-own-check"></div>
                    <div
                      v-if="isown"
                      class="form-group input-button-mines"
                      v-for="(data, index) in add_your_own_json"
                    >
                      <div>
                        <input
                          class="form-control"
                          type="text"
                          v-model="data.title"
                          @input="showselectedcv()"
                          name
                          placeholder="e.g. Hobbies"
                        >
                      </div>
                      <a class="btn-primary md-ink-ripple" @click.prevent="removeyourown(index)">
                        <i class="fa fa-minus"></i>
                      </a>
                    </div>
                    <div v-if="isown" class="btn-area-sec">
                      <a class="btn-primary md-ink-ripple" @click.prevent="Addyourown">
                        <i class="fa fa-plus"></i> Add
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div class="template-preview">
                  <div class="resume-template">
                    <div v-if="showResume">
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    <div v-if="showResumetwo">
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    <div v-if="showResumethree">
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    <div v-if="showResumefour">
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    <div v-if="showResumefive">
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    <div v-if="showResumesix">
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    <div v-if="showResumeseven">
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    <div v-if="showResumeeight">
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    <div v-if="showResumenine">
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    <div v-if="showResumetwelve">
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                  </div>
                  <div class="btn-select-template">
                    <a href="#" class="primary-btn preview" @click="previewResumeone">
                      <i class="material-icons">visibility</i> Preview
                    </a>
                    <a @click.prevent="Changetemplateprompt" data-toggle="modal" data-target="#ChnageTemplate" class="TemplateBtn">
                      <img src="../../assets/template.png" alt>
                      <span>
                        Change Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </div>
                </div>
                <!-- <div class="template-preview">
                  <img src="../../assets/view-resume.jpg" alt>
                  <img class="shadow" src="../../assets/transparent-black.png" alt>
                  <div class="btns">
                    <a @click.prevent="previewResumeone" class="primary-btn preview">
                      <i class="material-icons">visibility</i> Preview
                    </a>
                    <select v-model="template_name" @change="showselectedcv" class="form-control">
                      <option value="resume1.png">Template 1</option>
                      <option value="resume2.png">Template 2</option>
                      <option value="resume3.png">Template 3</option>
                      <option value="resume4.png">Template 4</option>
                    </select>
                  </div>
                </div>-->
              </div>
            </div>
          </div>

          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Save & Continue</a>
          </div>
        </div>
      </div>
      <div v-if="opencarousel" class="choose-template-sec">
        <span @click.prevent="opencarousel=false" class="material-icons popupclose">close</span>
        <carousel :items="5" v-if="opencarousel">
          <div
            @click.prevent="Handlecarousel(item)"
            v-for="(item, index) in cvTemplates"
            :key="index"
          >
            <img :src="item.img" :alt="item.name">
          </div>
        </carousel>
      </div>
    </body>
  </div>

  <div v-if="currentstep == 10">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li
                data-aos="active aos-init aos-animate"
                data-aos-duration="1000"
                class="active aos-init"
              >
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Accomplishments</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div class="search">
                        <multiselect
                          v-model="filterName"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular Search
                      </h6>
                      <ul>
                        <li class="active">
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="data in acc_list" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click.prevent="Addaccomplish(data)">
                            <i v-if="!accomplishments.includes(data)" class="fa fa-plus"></i>
                            <i v-if="accomplishments.includes(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div>
                  <h5
                    class="ckeditor-heading"
                    v-if="accomplishments!=''"
                  >Accomplishments Added</h5>
                  <div class="box">
                    <ckeditor v-model="accomplishments" :editor="editor"></ckeditor>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >{{stepname}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 11">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li
                data-aos="active aos-init aos-animate"
                data-aos-duration="1000"
                class="active aos-init"
              >
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Affiliations</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="left-form">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>Job Title</label>
                      <div class="search">
                        <multiselect
                          v-model="filterName"
                          :taggable="true"
                          @tag="onTagtitle($event)"
                          :options="jobtitlelist"
                          :multiple="false"
                        ></multiselect>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-5">
                    <div class="popular-search">
                      <h6>
                        <img src="../../assets/search.png" alt> Popular Search
                      </h6>
                      <ul>
                        <li class="active">
                          <a href="#">{{ filterName }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-xl-7">
                    <div class="ready-use-example">
                      <h6>Ready-to-use-examples</h6>
                      <div class="ready-use-scroll">
                        <div v-for="data in aff_list" class="box">
                          <div>
                            <i class="material-icons">star</i>
                            <div>
                              <p>Recommended</p>
                              <p>{{ data }}</p>
                            </div>
                          </div>
                          <a @click.prevent="Addaffiliation(data)">
                            <i v-if="!affiliations.includes(data)" class="fa fa-plus"></i>
                            <i v-if="affiliations.includes(data)" class="fa fa-minus"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right-form">
                <div >
                  <h5 class="ckeditor-heading" v-if="affiliations!=''">Affiliations Added</h5>
                  <div class="box">
                    <ckeditor v-model="affiliations" :editor="editor"></ckeditor>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >{{stepname}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 12">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li
                data-aos="active aos-init aos-animate"
                data-aos-duration="1000"
                class="active aos-init"
              >
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Additional information</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div>
                <div class="box">
                  <ckeditor v-model="additionals" :editor="editor"></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >{{stepname}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 13">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li
                data-aos="active aos-init aos-animate"
                data-aos-duration="1000"
                class="active aos-init"
              >
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Softwares</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div class="box">
                <ckeditor v-model="software" :editor="editor"></ckeditor>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Save & Continue</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 14">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li
                data-aos="active aos-init aos-animate"
                data-aos-duration="1000"
                class="active aos-init"
              >
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Language</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div >
                <div class="box">
                  <ckeditor v-model="language" :editor="editor"></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >{{stepname}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 15">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li
                data-aos="active aos-init aos-animate"
                data-aos-duration="1000"
                class="active aos-init"
              >
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Certification</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div>
                <div class="box">
                  <ckeditor v-model="certificate" :editor="editor"></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >Save & Continue</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 16">
    <div class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading">
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork">
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active aos-init aos-animate" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active aos-init" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li
                data-aos="active aos-init aos-animate"
                data-aos-duration="1000"
                class="active aos-init"
              >
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="aos-init">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <h3>Interest</h3>
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
              <div >
                <div class="box">
                  <ckeditor v-model="intrest" :editor="editor"></ckeditor>
                </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >{{stepname}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="currentstep == 17">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active" data-aos="fade-up" data-aos-duration="200">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="400">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="600">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="800">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1000">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li class="active" data-aos="fade-up" data-aos-duration="1200">
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right resume-preview">
          <!--<div class="top">
        <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="resume-preview-inner" data-aos="fade-up" data-aos-duration="800">
            <!-- <div class="previewTop">
              <div class="resume-edit">
                <a href="javascript:void(0);">
                  [davidjohn_resume]
                  <img src="../../assets/edit.png" alt>
                </a>
              </div>
            </div>-->
            <div class="resume-preview-section">
              <!-- <img src="Images/builder/resume-sample.png" alt="" /> -->
              <div v-if="showResume">
                <resumeonetemplate
                  ref="resumeone"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumeonetemplate>
              </div>
              <div v-if="showResumetwo">
                <resumetwotemplate
                  ref="resumetwo"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumetwotemplate>
              </div>
              <div v-if="showResumethree">
                <resumethreetemplate
                  ref="resumethree"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumethreetemplate>
              </div>
              <div v-if="showResumefour">
                <resumefourtemplate
                  ref="resumefour"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumefourtemplate>
              </div>
              <div v-if="showResumefive">
                <resumefivetemplate
                  ref="resumefive"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumefivetemplate>
              </div>
              <div v-if="showResumesix">
                <resumesixtemplate
                  ref="resumesix"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumesixtemplate>
              </div>
              <div v-if="showResumeseven">
                <resumeseventemplate
                  ref="resumeseven"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumeseventemplate>
              </div>
              <div v-if="showResumeeight">
                <resumeeighttemplate
                  ref="resumeeight"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumeeighttemplate>
              </div>
              <div v-if="showResumenine">
                <resumeninetemplate
                  ref="resumenine"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumeninetemplate>
              </div>
              <div v-if="showResumetwelve">
                <resumetwelvetemplate
                  ref="resumetwelve"
                  :parentObj="this"
                  :from="cvfrom"
                  :resume="resumeobj"
                ></resumetwelvetemplate>
              </div>
            </div>
          </div>
          <div class="bottom-preview">
            <div class="prview-box">
              <div class="btn-sec">
                <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>

                <ul class="bottom-preview-btn">
                  <li >
                    <a @click.prevent="Changetemplateprompt" data-toggle="modal" data-target="#ChnageTemplate">
                      <img src="../../assets/template.png" alt>
                      <span>
                        Template
                        <i class="material-icons">keyboard_arrow_down</i>
                      </span>
                    </a>
                  </li>
                  <li v-if="allow_cvjd_match">
                    <a @click.prevent="CVjdMatch">
                      <img src="../../assets/cv-jobs.png" alt>
                      <span>
                        CV & Job
                        <br>Description Match
                      </span>
                    </a>
                  </li>
                  <li v-if="allow_custom_cv">
                    <a @click.prevent="FirstGeneration">
                      <img src="../../assets/revise-your-resume.png" alt>
                      <span>Revise Your Resume</span>
                    </a>
                  </li>
                  <li v-if="Once_generate && summary != '' && allow_custom_cv">
                    <a @click.prevent="SummaryRegeneration">
                      <img src="../../assets/regenerate-summary.png" alt>
                      <span>Regenerate Summary</span>
                    </a>
                  </li>
                  <li v-if="Once_generate">
                    <a @click.prevent="aigeneratedprompt">
                      <img src="../../assets/check-changes.png" alt>
                      <span>Check Changes</span>
                    </a>
                  </li>
                </ul>

                <a @click.prevent="Saveresume" class="btn-primary md-ink-ripple">Save</a>
              </div>
            </div>
            <!-- <div class="prview-box">
                    <label>Template</label>
                    <a href="javascript:void(0);"><span>Crisp</span> <i class="material-icons">keyboard_arrow_down</i></a>
            </div>-->
            <!-- <div class="prview-box">
                    <label>Color</label>
                    <ul>
                        <li><div class="white"><span></span></div></li>
                        <li class="active"><div class="blue"><span></span></div></li>
                    </ul>
                    <i class="material-icons">keyboard_arrow_right</i>
                    <input data-toggle="tooltip" data-placement="top" title="Customize" type="color" name=""/>
            </div>-->
          </div>
        </div>
      </div>

    </body>
  </div>
  <div v-if="currentstep == 20">
    <body class="builder-page">
      <div class="top-header">
        <div class="top-left">
          <div class="logo">
            <a href="/Dashboard">
              <img src="../../assets/CC-Logo-White.svg" alt>
            </a>
          </div>
        </div>
        <div class="top-right">
          <a class="menu-toggle" href="#">
            <i class="material-icons">menu</i>
          </a>
        </div>
      </div>
      <div class="resume-builder-main">
        <div class="resume-builder-left">
          <!--<div class="logo">
                <a href="#"><img src="images/builder/CC-Logo-White.svg" alt="" /></a>
          </div>-->
          <div class="resume-section">
            <h3>Resume Sections</h3>
            <div class="logo">
              <a href="/Dashboard">
                <img src="/img/CC-Logo-White.1144d714.svg" alt>
              </a>
            </div>
            <ul>
              <li class="active">
                <a @click.prevent="Jumptoheading" href>
                  <span>1</span> Heading
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptowork" href>
                  <span>2</span> Experience
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoeducation" href>
                  <span>3</span> Education
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptoskill" href>
                  <span>4</span> Skills
                </a>
              </li>
              <li class="active">
                <a @click.prevent="Jumptosummary" href>
                  <span>5</span>Summary
                </a>
              </li>
              <li data-aos="fade-up" data-aos-duration="1200" class="active">
                <a @click.prevent="Jumptooptional" href>
                  <span>6</span> Others
                </a>
              </li>
              <li>
                <a @click.prevent="Jumptofinal" href>
                  <span>7</span> Finalize
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="resume-builder-right">
          <!--<div class="top">
                <a class="menu-toggle" href="#"><i class="material-icons">menu</i></a>
          </div>-->
          <div class="content skills-page">
            <div class="content-top-inner">
              <ul>
                <li>
                  <a @click.prevent="previewResumeone">
                    <img src="../../assets/preview-orange.png" alt> Preview
                  </a>
                </li>
                <li>
                  <a href="#">
                    <img src="../../assets/tips.png" alt> Tips
                  </a>
                </li>
              </ul>
            </div>

            <div class="form-section">
             <div>
              <div class="mb-5" v-for="(data, index) in add_your_own_json">
                <h3 class="mb-2">{{ data.title }}</h3>
                <div class="box">
                  <ckeditor v-model="data.body" :editor="editor"></ckeditor>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div class="btn-sec">
            <a @click.prevent="back(currentstep)" class="btn-secondary md-ink-ripple">Back</a>
            <a
              @click.prevent="nextstep(currentstep)"
              class="btn-primary md-ink-ripple"
            >{{stepname}}</a>
          </div>
        </div>
      </div>
    </body>
  </div>
  <transition name="fade">
    <Messages
      v-if="isdisplaymsg"
      :datamessage="sucessmsgtext"
      v-on:closemsg="closeMessage"
      v-bind:isVisible="isdisplaymsg"
    ></Messages>
  </transition>
  <ConfirmBox
    ref="confirmcomp"
    :showmodal="showCnfrmPopUp"
    :actionmessage="actionMsg"
    @cancelAction="
    showCnfrmPopUp = false;
  "
    @confirmAction="Delete()"
  ></ConfirmBox>
  <div v-if="loader" class="template-loader-hiw hide">
    <div class="loader-overlay"></div>
    <div class="progress-bar-wrapper">
      <img
        src="../../assets/check-circle.svg"
        v-if="finished"
        alt="Check Circle"
        width="48"
        height="48"
        class="icon-check-circle hide"
      >
      <p class="progress-text step1">{{ loadermsg }}</p>
      <div v-if="!finished" class="progress-bar">
        <div class="progress-linear"></div>
        <div class="progress-gradient progress-animate"></div>
      </div>
    </div>
  </div>

  <div
    class="modal fade imgPreview"
    id="ChnageTemplate"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Change template</h5>
          <button type="button" class="close" data-dismiss="modal" @click.prevent="CancelTemplatechange" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-7 pr-0">
              <div class="ResumePreview">
                <div class="ResumeFullPreview">
                  <div v-if="popupresume==1">
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    <div v-if="popupresume==2">
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    <div v-if="popupresume==3">
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    <div v-if="popupresume==4">
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    <div v-if="popupresume==5">
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    <div v-if="popupresume==6">
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    <div v-if="popupresume==7">
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    <div v-if="popupresume==8">
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    <div v-if="popupresume==9">
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    <div v-if="popupresume==12">
                      <resumetwelvetemplate
                        ref="resumetwelve"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                </div>
              </div>
            </div>
            <div class="col-md-5 pl-0">
              <div class="TemplateSelector">
                <div class="ColorPanel">
                  <span class="color-panel-title">Choose color:</span>

                  <ul class="color-selector">
                    <li>
                      <label class="color-selector-reset">
                        <span
                          @click.prevent="changeBackgroundColor(previousColor)"
                          class="color-selector-radio"
                          style="background:rgb(255, 255, 255);"
                        ></span>
                      </label>
                    </li>
                    <li>
                      <label title="Nobel Grey" class="label" :class="{'active':(hoveredColor=='#7d7d7d'||hoveredColor=='#34383c'||hoveredColor=='#e4e2de')}">
                        <span
                          class="color-selector-radio"                       
                          @click.prevent="changeBackgroundColor('#7d7d7d')"
                          style="background: rgb(125, 125, 125);"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Outer Space" class="label">
                            <span
                              class="color-selector-radio"
                              @click.prevent="changeBackgroundColor('#34383c')"
                              style="background: rgb(52, 56, 60);"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Silver White" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(228, 226, 222);"
                              @click.prevent="changeBackgroundColor('#e4e2de')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label
                        title="Oxford Blue"
                        class="label"
                        :class="{'active':(hoveredColor=='#102a73'||hoveredColor=='#a3b8de'||hoveredColor=='#394d6b')}"
                        
                        @click.prevent="changeBackgroundColor('#102a73')"
                      >
                        <span class="color-selector-radio" style="background: rgb(16, 42, 115);"></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Steel Blue" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(163, 184, 222);"
                              @click.prevent="changeBackgroundColor('#a3b8de')"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Denim Blue" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(57, 77, 107);"
                              @click.prevent="changeBackgroundColor('#394d6b')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Olympic Blue" class="label" :class="{'active':(hoveredColor=='#2b98de'||hoveredColor=='#094d73'||hoveredColor=='#8ac3f5')}">
                        <span
                          class="color-selector-radio"
                          @click.prevent="changeBackgroundColor('#2b98de')"
                          style="background: rgb(43, 152, 222);"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Slate Blue" class="label">
                            <span
                              class="color-selector-radio"
                              @click.prevent="changeBackgroundColor('#094d73')"
                              style="background: rgb(9, 77, 115);"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Carolina Blue" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(138, 195, 245);"
                              @click.prevent="changeBackgroundColor('#8ac3f5')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Turquoise" class="label"  :class="{'active':(hoveredColor=='#00bca3'||hoveredColor=='#016b5d'||hoveredColor=='#b5e8e2')}">
                        <span
                          class="color-selector-radio"
                          @click.prevent="changeBackgroundColor('#00bca3')"
                          style="background: rgb(0, 188, 163);"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Empress Teal" class="label">
                            <span
                              class="color-selector-radio"
                              @click.prevent="changeBackgroundColor('#016b5d')"
                              style="background: rgb(1, 107, 93);"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Mint Teal" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(181, 232, 226);"
                              @click.prevent="changeBackgroundColor('#b5e8e2')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Jungle Green" class="label" :class="{'active':(hoveredColor=='#075700'||hoveredColor=='#b7d1ad'||hoveredColor=='#789c30')}">
                        <span
                          class="color-selector-radio"
                          @click.prevent="changeBackgroundColor('#075700')"
                          style="background: rgb(7, 87, 0);"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Pixie Green" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(183, 209, 173);"
                              @click.prevent="changeBackgroundColor('#b7d1ad')"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Moss Green" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(120, 156, 48);"
                              @click.prevent="changeBackgroundColor('#789c30')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Tuscan Yellow" class="label" :class="{'active':(hoveredColor=='#facd05'||hoveredColor=='#cd8b00'||hoveredColor=='#c4b08f')}">
                        <span
                          class="color-selector-radio"
                          style="background: rgb(250, 205, 5);"
                          @click.prevent="changeBackgroundColor('#facd05')"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Medallion" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(205, 139, 0);"
                              @click.prevent="changeBackgroundColor('#cd8b00')"
                            ></span>
                            <!-- <input
                              type="radio"
                              aria-checked="false"
                              data-color="#cd8b00"
                              data-label="Medallion"
                              value="#cd8b00"
                              @mouseover="changeBackgroundColor('#cd8b00')"
                              
                             
                            >-->
                          </label>
                        </li>
                        <li>
                          <label title="Sand Dollar" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(196, 176, 143);"
                              @click.prevent="changeBackgroundColor('#c4b08f')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Indian Red" class="label" :class="{'active':(hoveredColor=='#9b3016'||hoveredColor=='#e37929'||hoveredColor=='#c46531')}">
                        <span
                          class="color-selector-radio"
                          style="background: rgb(155, 48, 22);"
                          @click.prevent="changeBackgroundColor('#9b3016')"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Orange Sunrise" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(227, 121, 41);"
                              @click.prevent="changeBackgroundColor('#e37929')"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Red Fox" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(196, 101, 49);"
                              @click.prevent="changeBackgroundColor('#c46531')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <label title="Contessa Rose" class="label" :class="{'active':(hoveredColor=='#f98c79'||hoveredColor=='#8c3c4b'||hoveredColor=='#f7bfb5')}">
                        <span
                          class="color-selector-radio"
                          style="background: rgb(249, 140, 121);"
                          @click.prevent="changeBackgroundColor('#f98c79')"
                        ></span>
                      </label>
                      <ul class="color-dropdown">
                        <li>
                          <label title="Camelot" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(140, 60, 75);"
                              @click.prevent="changeBackgroundColor('#8c3c4b')"
                            ></span>
                          </label>
                        </li>
                        <li>
                          <label title="Azalea Pink" class="label">
                            <span
                              class="color-selector-radio"
                              style="background: rgb(247, 191, 181);"
                              @click.prevent="changeBackgroundColor('#f7bfb5')"
                            ></span>
                          </label>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>

                <div class="ResumePanel">
                  <div @click.prevent="popupresume=1" class="ThumbPreview">
                    <div>
                      <resumeonetemplate
                        ref="resumeone"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeonetemplate>
                    </div>
                    
                  </div>
                  <div @click.prevent="popupresume=2" class="ThumbPreview">
                    <div >
                      <resumetwotemplate
                        ref="resumetwo"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwotemplate>
                    </div>
                    
                  </div>
                  <div @click.prevent="popupresume=3" class="ThumbPreview">
                    <div >
                      <resumethreetemplate
                        ref="resumethree"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumethreetemplate>
                    </div>
                    
                  </div>
                  <div @click.prevent="popupresume=4" class="ThumbPreview">
                    <div >
                      <resumefourtemplate
                        ref="resumefour"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefourtemplate>
                    </div>
                    
                  </div>
                  <div @click.prevent="popupresume=5" class="ThumbPreview">
                    <div >
                      <resumefivetemplate
                        ref="resumefive"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumefivetemplate>
                    </div>
                    
                  </div>
                  <div @click.prevent="popupresume=6" class="ThumbPreview">
                    <div >
                      <resumesixtemplate
                        ref="resumesix"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumesixtemplate>
                    </div>
                    
                  </div>
                  <div @click.prevent="popupresume=7" class="ThumbPreview">
                    <div >
                      <resumeseventemplate
                        ref="resumeseven"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeseventemplate>
                    </div>
                    
                  </div>
                  <div @click.prevent="popupresume=8" class="ThumbPreview">
                    <div >
                      <resumeeighttemplate
                        ref="resumeeight"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeeighttemplate>
                    </div>
                    
                  </div>
                  <div @click.prevent="popupresume=9" class="ThumbPreview">
                    <div >
                      <resumeninetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumeninetemplate>
                    </div>
                    
                  </div>
                  <div @click.prevent="popupresume=12" class="ThumbPreview">
                    <div >
                      <resumetwelvetemplate
                        ref="resumenine"
                        :parentObj="this"
                        :from="cvfrom"
                        :resume="resumeobj"
                      ></resumetwelvetemplate>
                    </div>
                    
                  </div>
                </div>

                <div class="ResumeBottomPanel">
                  <button type="button" @click.prevent="HandleTemplatechange" class="primary-btn">Select this template</button>
                  <button type="button" @click.prevent="CancelTemplatechange" class="secondary-btn">Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    id="aigeneratedprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-check-changes modal-content">
        <div class="modal-header border-0 p-0">
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <div class>
            <h3>Summary</h3>
            <div v-if="genSumm_list.length>0" class="mt-3">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th width="10%">Old</th>
                    <th width="10%">New</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in genSumm_list">
                    <td v-html="item.old"></td>
                    <td v-html="item.new"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p>Summary not generated yet</p>
            </div>
          </div>
          <div class>
            <h3>Skills</h3>
            <div v-if="genSkill_list.length>0" class="mt-3">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th width="10%">Old</th>
                    <th width="10%">New</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in genSkill_list">
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p>Skills not generated yet</p>
            </div>
          </div>
          <div class>
            <h3>Targeted Job Title</h3>
            <div v-if="genJobtitle_list.length>0" class="mt-3">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th width="10%">Old</th>
                    <th width="10%">New</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in genJobtitle_list">
                    <td v-html="item.old"></td>
                    <td v-html="item.new"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <p>Job title not generated yet</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumeprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumeonetemplate :resume="resumeobj"></resumeonetemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumetwoprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumetwotemplate :resume="resumeobj"></resumetwotemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumethreeprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumethreetemplate :resume="resumeobj"></resumethreetemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumefourprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumefourtemplate :resume="resumeobj"></resumefourtemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumefiveprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumefivetemplate :resume="resumeobj"></resumefivetemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumesixprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumesixtemplate :resume="resumeobj"></resumesixtemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumesevenprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumeseventemplate :resume="resumeobj"></resumeseventemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumeeightprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumeeighttemplate :resume="resumeobj"></resumeeighttemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumenineprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumeninetemplate :resume="resumeobj"></resumeninetemplate>
        </div>
      </div>
    </div>
  </div>
  <div
    id="resumetwelveprompt"
    role="dialog"
    tabindex="-1"
    class="modal fade imgPreview"
    aria-modal="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title mb-4">Resume Preview</h3>
          <button type="button" data-dismiss="modal" class="close">×</button>
        </div>
        <div class="modal-body">
          <resumetwelvetemplate :resume="resumeobj"></resumetwelvetemplate>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Axios from "axios";
import Leftmenu from "@/components/Leftmenu.vue";
import multiselect from "vue-multiselect";
import rest_service from "@/api/rest_service_api.js";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Header from "@/components/Header.vue";
import resumeoneviewer from "@/components/resumeone.vue";
import Vue from "vue";
import moment from "moment";
import "flatpickr/dist/flatpickr.css";
import resumetwoviewer from "@/components/resumetwo.vue";
import flatpickr from "flatpickr";
import resumeonetemplate from "@/components/resumeTemplate/resumeone_template.vue";
import resumetwotemplate from "@/components/resumeTemplate/resumetwo_template.vue";
import resumethreetemplate from "@/components/resumeTemplate/resumethree_template.vue";
import resumefourtemplate from "@/components/resumeTemplate/resumefour_template.vue";
import resumefivetemplate from "@/components/resumeTemplate/resumefive_template.vue";
import resumesixtemplate from "@/components/resumeTemplate/resumesix_template.vue";
import resumeseventemplate from "@/components/resumeTemplate/resumeseven_template.vue";
import resumeeighttemplate from "@/components/resumeTemplate/resumeeight_template.vue";
import resumeninetemplate from "@/components/resumeTemplate/resumenine_template.vue";
import resumetwelvetemplate from "@/components/resumeTemplate/resumetwelve_template.vue";
import ItemTemplate from "@/components/AutocompleteTemplate/Geolocation.vue";
import Autocomplete from "v-autocomplete";
import carousel from "vue-owl-carousel";
import ConfirmBox from "@/components/MessagePopup/ConfirmPopup";
import Messages from "@/components/MessagePopup/Messages";
Vue.use(Autocomplete);
var customer = null;
var customer_ed = null;
Vue.use(flatpickr);

export default {
  components: {
    ckeditor: CKEditor.component,
    Header,
    carousel,
    ConfirmBox,
    Messages,
    Leftmenu,
    // resumeoneviewer,
    multiselect,
    resumetwotemplate,
    resumeonetemplate,
    resumethreetemplate,
    resumefourtemplate,
    resumefivetemplate,
    resumesixtemplate,
    resumeseventemplate,
    resumeeighttemplate,
    resumeninetemplate,
    resumetwelvetemplate
    // resumeoneviewer: () => import("@/components/resumeone.vue"),
  },
  data() {
    return {
     editor: ClassicEditor,
      // editorConfig: {
      //   toolbar: {
      //     items: [
      //       "heading",
      //       "|",
      //       "bold",
      //       "italic",
      //       "|",
      //       "bulletedList",
      //       "numberedList",
      //       "|",
      //       "insertTable",
      //       "|",
      //       "imageUpload",
      //       "|",
      //       "undo",
      //       "redo"
      //     ]
      //   }
      // },
      Add_work: false,
      Add_ed: false,
      stepname:"Save & Continue",
      cvTemplates: [
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume1.png",
          name: "resume1.png"
        },
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume2.png",
          name: "resume2.png"
        },
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume3.png",
          name: "resume3.png"
        },
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume4.png",
          name: "resume4.png"
        },
        {
          img: "https://genamet-static-uploads.s3.amazonaws.com/CV/resume5.png",
          name: "resume5.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-6.jpg",
          name: "resume6.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-7.jpg",
          name: "resume7.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-8.jpg",
          name: "resume8.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-9.jpg",
          name: "resume9.png"
        },
        {
          img:
            "https://genamet-static-uploads.s3.amazonaws.com/CV/resume-12.jpg",
          name: "resume10.png"
        }
      ],
      popupresume:1,
      opencarousel: false,
      Schooldesc: "",
      perfectmatch: false,
      match_percentage: "",
      Reason: "",
      Once_generate: false,
      loader: false,
      finished: false,
      loadermsg: "",
      isdisplaymsg: false,
      sucessmsgtext: "",
      what_index: 0,
      delete_what: "",
      actionMsg: "",
      showCnfrmPopUp: false,
      isJobdesc: false,
      Job_desc: "",
      mmyyyy: false,
      grad_mmyyyy: false,
      currentstudy: false,
      currentwork: false,
      err_jd: false,
      err_email_regex: false,
      err_phone: false,
      err_name: false,
      err_prof: false,
      add_your_own_json: [],
      own_id: 0,
      template: ItemTemplate,
      pic:
        "data:image/png;base64,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",
      temp_pic:
        "data:image/png;base64,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",
      currentstep: 0,
      genJobtitle_list: [],
      genSumm_list: [],
      genSkill_list: [],
      description: "",
      First_Name: "",
      Last_Name: "",
      Profession: "",
      ext_Profession: "",
      City: "",
      Country: "",
      Pin_code: "",
      Phone: "",
      Email: "",
      Linkedin: "",
      Website: "",
      Twitter: "",
      Address: "",
      Work_id: 1,
      Job_Title: "",
      Employer: "",
      Work_City: "",
      Work_Country: "",
      Start_Date: "",
      End_Date: "",
      Ed_id: 1,
      School_loc: "",
      School_name: "",
      School_degree: "",
      Field_study: "",
      Grad_startdate: "",
      Grad_Enddate: "",
      School_desc: "",
      steps: [],
      jobtitlelist: [],
      filterName: "",
      WorkDesc: [],
      resumeobj: {},
      work: [],
      tempwork: [],
      Education: [],
      tempEducation: [],
      Skill_list: [],
      Summary_list: [],
      acc_list: [],
      aff_list: [],
      skill: [],
      ext_skill: [],
      skills: [],
      summary: "",
      ext_summary: "",
      affiliations: "",
      accomplishments: "",
      additionals: "",
      software: "",
      language: "",
      certificate: "",
      intrest: "",
      isEddesc: true,
      isaccomplishment: false,
      isaffilation: false,
      isown: false,
      isadditional: false,
      islang: false,
      issoftware: false,
      iscertificate: false,
      isintrest: false,
      showResume: false,
      showResumetwo: false,
      showResumethree: false,
      showResumefour: false,
      showResumefive: false,
      showResumesix: false,
      showResumeseven: false,
      showResumeeight: false,
      showResumenine: false,
      isfinal: false,
      cvfrom: "edit",
      Unique_id: "",
      indexToUpdate: 0,
      indexToEDUpdate: 0,
      cities: [],
      customers: [],
      customer,
      customer_ed,
      template_name: "",
      allow_custom_cv: false,
      allow_cvjd_match: false,
      maxRating: 5,
      issocial: true,
      hoveredColor:"",
      previousColor:"rgb(0, 151, 178)",

    };
  },
  created() {
    if (localStorage.getItem("cv_package")) {
      var cv = JSON.parse(localStorage.getItem("cv_package"));
      if (parseInt(cv.usedNoCvGenerate) >= parseInt(cv.maxNoCvGenerate)) {
        this.allow_custom_cv = false;
      } else {
        this.allow_custom_cv = true;
      }
    } else {
      this.allow_custom_cv = false;
    }
    if (localStorage.getItem("cvjd_package")) {
      var cv = JSON.parse(localStorage.getItem("cvjd_package"));
      if (parseInt(cv.usedNoCvjdMatch) >= parseInt(cv.maxNocvjdMatch)) {
        this.allow_cvjd_match = false;
      } else {
        this.allow_cvjd_match = true;
      }
    } else {
      this.allow_cvjd_match = false;
    }
    this.currentstep = 17;
    this.GetJobTitle();
    this.EditCV();
  },
  mounted() {},
  updated() {
    $('[data-toggle="tooltip"]').tooltip();
   
    

    $(function () {
       $('[data-toggle="tooltip"]').tooltip({
           trigger : 'hover'
       });
     
       $('[data-toggle="tooltip"]').on('click', function () {
         $(this).tooltip('hide')
       });
    });
    $(document).ready(function() {
      $(".menu-toggle").click(function() {
        $(".resume-builder-main").toggleClass("active");
      });
    });

    $(window).scroll(function() {
      if ($(this).scrollTop() > 50) {
        $(".resume-builder-right .top").addClass("fixed");
      } else {
        $(".resume-builder-right .top").removeClass("fixed");
      }
    });
    if (this.mmyyyy) {
      this.StartDateChange();
    } else {
      this.StartDateChange_withdd();
    }
    if (this.grad_mmyyyy) {
      this.GradStartDateChange();
    } else {
      this.GradStartDateChange_withdd();
    }
    if (this.currentstep == 5) {
      $("#gradstart_date_selected").addClass("t-valid");
      $("#gradend_date_selected").addClass("t-valid");
    }
    if (this.currentstep == 2) {
      $("#start_date_selected").addClass("t-valid");
      $("#end_date_selected").addClass("t-valid");
    }
  },
  computed: {
    ratings() {
      return Array.from({ length: this.maxRating }, (_, i) => i + 1);
    }
  },
  methods: {
    changeBackgroundColor(color) {
      this.hoveredColor = color; // Update hovered color
      this.previewResume();
    },
    setRating(rating, item) {
      item.rate = rating;
    },
    AddSociallink() {
      this.issocial = !this.issocial;
    },
    addmoreskill() {
      var self = this;
      var skilljson = {
        text: "",
        rate: 0
      };
      self.skill.push(skilljson);
    },
    removeskill(index) {
      this.skill.splice(index, 1);
    },
    addeddescs() {
      var self = this;
      if (self.School_desc.includes(self.Schooldesc)) {
        // self.opeining =self.opeining+ item;
        self.School_desc = self.School_desc.replace(self.Schooldesc, "").trim();
      } else {
        self.School_desc = self.School_desc + "\n \u2022" + self.Schooldesc;
      }
      // this.School_desc=this.School_desc+"\n"+this.Schooldesc;
    },
    haveJobdesc(item) {
      if (item == "no") {
        this.currentstep = 17;
        this.isJobdesc = false;
      }
      if (item == "yes") {
        this.isJobdesc = true;
        this.currentstep = 21;
      }
    },
    Jumptoheading() {
      this.currentstep = 1;
    },
    Jumptowork() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 4;
    },
    Jumptoeducation() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 6;
    },
    Jumptosummary() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 8;
    },
    Jumptoskill() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 7;
    },
    Jumptooptional() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) this.currentstep = 9;
    },
    Jumptofinal() {
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      if (!this.validateprofile()) {
        this.currentstep = 17;
        this.showselectedcv();
      }
    },
    givedate(inputDate) {
      const parts = inputDate.split("/");
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      const day = parseInt(parts[0], 10);
      const newDate = new Date(year, month - 1, day);
      return newDate;
    },
    givedate_mmyyyy(inputDate) {
      const parts = inputDate.split("/");
      const month = parseInt(parts[0], 10);
      const year = parseInt(parts[1], 10);
      const day = 1;
      const newDate = new Date(year, month - 1, day);
      return newDate;
    },
    verifyworkdate_mmyyyy() {
      if (this.Start_Date != "" && this.End_Date != "") {
        var sdate = this.givedate_mmyyyy(this.Start_Date);
        var edate = this.givedate_mmyyyy(this.End_Date);
        if (sdate > edate) {
          this.End_Date = "";
        }
      }
    },
    verifyeddate_mmyyyy() {
      if (this.Grad_startdate != "" && this.Grad_Enddate) {
        var sdate = this.givedate_mmyyyy(this.Grad_startdate);
        var edate = this.givedate_mmyyyy(this.Grad_Enddate);
        if (sdate > edate) {
          this.Grad_Enddate = "";
        }
      }
    },
    verifywork_date() {
      if (this.Start_Date != "" && this.End_Date != "") {
        var sdate = this.givedate(this.Start_Date);
        var edate = this.givedate(this.End_Date);
        if (sdate > edate) {
          this.End_Date = "";
        }
      }
    },
    verifyeddate() {
      if (this.Grad_startdate != "" && this.Grad_Enddate) {
        var sdate = this.givedate(this.Grad_startdate);
        var edate = this.givedate(this.Grad_Enddate);
        if (sdate > edate) {
          this.Grad_Enddate = "";
        }
      }
    },
    submittomatch() {
      var self = this;
      if (self.Job_desc != "") {
        self.loadermsg = "Calculating....";
        self.loader = true;
        self.finished = false;
        var totalyears = 0;
        if (self.work != "" && self.work != null) {
          var Totalexp = 0;
          var totaltime = 0;
          self.work.forEach(item => {
            if (
              item.startdate != null &&
              item.startdate != "" &&
              item.enddate != null &&
              item.enddate != ""
            ) {
              var years = self.calculateYearsDifference(
                item.startdate,
                item.enddate
              );
              if (years != null && years != undefined) {
                totaltime = totaltime + years;
              }
            }
          });
          Totalexp = totaltime / (1000 * 60 * 60 * 24 * 365.25);
          if (Totalexp != 0) {
            var afterround = Math.round(Totalexp);
            if (afterround != null) {
              if (afterround === 0) {
                totalyears = "Less than one";
              } else {
                totalyears = afterround.toString();
              }
            }
          }
        }
        var skilltxt = "";
        if (self.skill.length > 0) {
          self.skill.forEach(t => {
            if (t.rate != 0) {
              skilltxt =
                skilltxt +
                " " +
                t.text +
                " Rating is " +
                self.maxRating +
                " out of " +
                self.maxRating +
                ", ";
            } else {
              skilltxt = skilltxt + " " + t.text;
            }
          });
        } else {
          skilltxt = "None";
        }
        var file = {
          work_experience:
            JSON.stringify(self.work) +
            " Total number of Experience in Years is " +
            totalyears,
          education: JSON.stringify(self.Education),
          skills: JSON.stringify(self.skill),
          job_description: self.Job_desc,
          summary: self.summary
        };
        Axios({
          method: "post",
          url: rest_service.PythonAPI + "/cv_jd_percentage",
          //url: "https://lin-resumebuilder.careercubicle.com/analyze_cv",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          data: file
        })
          .then(function(response) {
            if (response.data.content) {
              var Data = response.data;
              const sanitizedJSONString = Data.content.replace(
                /[\x00-\x1F\x7F-\x9F]/g,
                ""
              );
              var Content = JSON.parse(sanitizedJSONString);
              self.match_percentage = Content.match_percentage;
              //self.Reason = Content.reason;
              var percent;
              if (Content.match_percentage != "") {
                percent = parseInt(Content.match_percentage);
              }
              if (percent >= 80) {
                self.perfectmatch = true;
                self.Reason = self.replaceNumericalValuesWithText(
                  Content.reason,
                  "high"
                );
              } else if (percent < 80 && percent >= 50) {
                self.perfectmatch = false;
                self.match_percentage = "Low";
                self.Reason = self.replaceNumericalValuesWithText(
                  Content.reason,
                  "Low"
                );
              } else {
                self.perfectmatch = false;
                self.match_percentage = "Very Low";
                self.Reason = self.replaceNumericalValuesWithText(
                  Content.reason,
                  "Very Low"
                );
              }
              var cv = JSON.parse(localStorage.getItem("cvjd_package"));
              var number = parseInt(cv.usedNoCvjdMatch) + 1;
              self.updatelimit("jdmatch", number);
              self.loadermsg = "Finished";
              self.finished = true;
              setTimeout(xy => {
                self.closeloader();
              }, 3000);
              self.currentstep = 24;
            } else {
              self.loadermsg = "Something wrong. Try after sometime.";
              setTimeout(xy => {
                self.closeloader();
              }, 3000);
              return null;
            }
          })
          .catch(function(error) {
            self.loadermsg = "Something wrong. Try after sometime.";
            setTimeout(xy => {
              self.closeloader();
            }, 3000);
            console.log(error);
            return error;
          });
      } else {
        self.err_jd = true;
      }
    },
    submittocustomize() {
      var self = this;
      if (self.Job_desc != "") {
        self.loadermsg = "personalizing....";
        self.loader = true;
        self.finished = false;
        var skilltxt = "";
        if (self.skill.length > 0) {
          self.skill.forEach(t => {
            skilltxt =
              skilltxt +
              " " +
              t.text +
              " Rating is " +
              t.rate +
              " out of " +
              self.maxRating +
              ", ";
          });
        } else {
          skilltxt = "None";
        }
        var file = {
          work_experience: JSON.stringify(self.work),
          education: JSON.stringify(self.Education),
          skills: skilltxt,
          job_description: self.Job_desc
        };
        Axios({
          method: "post",
          url: rest_service.PythonAPI + "/customize_cv_api",
          //url: "https://lin-resumebuilder.careercubicle.com/analyze_cv",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          data: file
        })
          .then(function(response) {
            if (response.data.content) {
              var Data = response.data;
              const sanitizedJSONString = Data.content.replace(
                /[\x00-\x1F\x7F-\x9F]/g,
                ""
              );
              var Content = JSON.parse(sanitizedJSONString);
              // var Content = JSON.parse(response.data.content);
              var percent;
              var match = false;
              if (self.perfectmatch == false) {
                if (Content.match_percentage != "") {
                  percent = parseInt(Content.match_percentage);
                }
                if (percent >= 80) {
                  match = true;
                } else {
                  match = false;
                }
              }
              if (match == true || self.perfectmatch) {
                self.genSkill_list = [];
                self.genSumm_list = [];
                self.genJobtitle_list = [];
                var temp = JSON.parse(JSON.stringify(self.skill));
                var temp1 = Content.skills;
                temp.push(temp1);
                var newskill = temp;
                var skilljson = {
                  old: self.skill,
                  new: newskill
                };
                self.genSkill_list.push(skilljson);
                const array = Content.skills.split(",");
                array.forEach(item => {
                  if (!self.skillrepeat(item)) {
                    var skill_json = {
                      text: item,
                      rate: 0
                    };
                    self.skill.push(skill_json);
                  }
                });
                // const array = Content.skills.split(",");
                // array.forEach(item => {
                //   self.skill = self.skill + "<br>\u2022" + item;
                // });
                //.skill = self.skill + Content.skills;
                var summjson = {
                  old: self.summary,
                  new: Content.summary,
                  isregen: false
                };
                self.genSumm_list.push(summjson);
                self.summary = Content.summary;
                var jobtitlejson = {
                  old: self.Profession,
                  new: Content.jobtitle
                };
                self.genJobtitle_list.push(jobtitlejson);
                self.Profession = Content.jobtitle;
                self.showselectedcv();
              } else {
                const array = Content.skills.split(",");
                // array.forEach(item => {
                //   self.ext_skill = self.skill + "<br>\u2022" + item;
                // });
                self.ext_skill = [];
                array.forEach(item => {
                  if (!self.skillrepeat(item)) {
                    var skill_json = {
                      text: item,
                      rate: 0
                    };
                    self.ext_skill.push(skill_json);
                  }
                });
                self.ext_summary = Content.summary;
                self.ext_Profession = Content.jobtitle;
              }
              debugger;
              var cv = JSON.parse(localStorage.getItem("cv_package"));
              var number = parseInt(cv.usedNoCvGenerate) + 1;
              self.updatelimit("cv", number);
              self.loadermsg = "Finished";
              self.finished = true;

              setTimeout(xy => {
                self.closeloader();
              }, 3000);
              self.currentstep = 17;
              self.Job_desc = "";
              if (match == true || self.perfectmatch) {
                self.Once_generate = true;
              } else {
                self.LowGeneration();
              }
              self.perfectmatch = false;
            } else {
              self.loadermsg = "Something wrong. Try after sometime.";
              setTimeout(xy => {
                self.closeloader();
              }, 3000);
              return null;
            }
          })
          .catch(function(error) {
            self.loadermsg = "Something wrong. Try after sometime.";
            setTimeout(xy => {
              self.closeloader();
            }, 3000);
            console.log(error);
            return error;
          });
      } else {
        self.err_jd = true;
      }
    },
    closeloader() {
      var self = this;
      self.loader = false;
      self.finished = false;
    },
    submittoregenerate() {
      var self = this;

      self.loadermsg = "Regenerating....";
      self.loader = true;
      self.finished = false;
      var file = {
        summary: self.summary
      };
      Axios({
        method: "post",
        url: rest_service.PythonAPI + "/regenerate_summary",
        //url: "https://lin-resumebuilder.careercubicle.com/analyze_cv",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        data: file
      })
        .then(function(response) {
          if (response.data.content) {
            debugger;
            var Content = JSON.parse(response.data.content);
            if (Content.summary) {
              self.genSumm_list = [];
              var summjson = {
                old: self.summary,
                new: Content.summary,
                isregen: true
              };
              self.genSumm_list.push(summjson);
              self.summary = Content.summary;
            }
            self.showselectedcv();
            var cv = JSON.parse(localStorage.getItem("cv_package"));
            var number = parseInt(cv.usedNoCvGenerate) + 1;
            self.updatelimit("cv", number);
            self.loadermsg = "Finished";
            self.finished = true;
            setTimeout(xy => {
              self.closeloader();
            }, 3000);
            self.currentstep = 17;
          } else {
            self.loadermsg = "Something wrong. Try after sometime.";
            setTimeout(xy => {
              self.closeloader();
            }, 3000);
            return null;
          }
        })
        .catch(function(error) {
          self.loadermsg = "Something wrong. Try after sometime.";
          setTimeout(xy => {
            self.closeloader();
          }, 3000);
          console.log(error);
          return error;
        });
    },
    updatelimit(name, number) {
      var uid;
      if (localStorage.getItem("loggedinuserobj")) {
        uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      }
      var pack_id;
      if (name == "cv") {
        pack_id = localStorage.getItem("package_uniqueid");
      } else {
        var jd = JSON.parse(localStorage.getItem("cvjd_package"));
        pack_id = jd.purchasedPackageUniqueId;
      }
      var file = {
        Uniqueid: pack_id,
        Name: name,
        No: number
      };
      Axios({
        method: "post",
        url: rest_service.baseURL + "/User/UpdateUsageBasedOnType",
        // url: "https://localhost:7101/api" + "/User/UpdateUsageBasedOnType",
        data: file,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + uid.returnedToken
        }
      })
        .then(function(response) {
          if (response) {
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        })
        .finally(() => {
          this.Getlimit();
        });
    },
    Getlimit() {
      var self = this;
      debugger;
      var uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      Axios({
        method: "get",
        url: rest_service.baseURL + "/User/GetUserActivePackage",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + uid.returnedToken
        },
        params: {
          email: uid.user.email
        }
      })
        .then(function(response) {
          if (response.data) {
            if (response.data.result.length > 0) {
              self.IsCvAllowed(response.data.result);
              self.IsCvjdMatchAllowed(response.data.result);
            }
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    IsCvAllowed(item) {
      var self = this;
      self.allow_custom_cv = false;
      localStorage.removeItem("package_uniqueid");
      localStorage.removeItem("cv_package");
      item.forEach(e => {
        debugger;
        if (e.saveCv) {
          if (parseInt(e.maxNoCvGenerate) > parseInt(e.usedNoCvGenerate)) {
            self.allow_custom_cv = true;
            localStorage.setItem(
              "package_uniqueid",
              e.purchasedPackageUniqueId
            );
            localStorage.setItem("cv_package", JSON.stringify(e));
            return;
          }
        }
      });
    },
    IsCvjdMatchAllowed(item) {
      var self = this;
      self.allow_cvjd_match = false;
      localStorage.removeItem("cvjd_package");
      item.forEach(e => {
        debugger;
        if (e.matchJobDescriptionCv) {
          if (parseInt(e.maxNocvjdMatch) > parseInt(e.usedNoCvjdMatch)) {
            self.allow_cvjd_match = true;
            localStorage.setItem("cvjd_package", JSON.stringify(e));
            return;
          }
        }
      });
    },
    Delete() {
      this.showCnfrmPopUp = false;
      if (this.delete_what == "Education") {
        this.Education.splice(this.what_index, 1);
        this.sucessmsgtext = "Deleted successfully";
        this.isdisplaymsg = true;
        setTimeout(xy => {
          this.closeMessage();
        }, 5000);
      }
      if (this.delete_what == "Work") {
        this.work.splice(this.what_index, 1);
        this.sucessmsgtext = "Deleted successfully";
        this.isdisplaymsg = true;
        setTimeout(xy => {
          this.closeMessage();
        }, 5000);
      }
      if (this.delete_what == "Jd") {
        this.err_jd = false;
        this.currentstep = 17;
      }
      if (this.delete_what == "Regenerate") {
        this.submittoregenerate();
      }
      if (this.delete_what == "Generate") {
        this.currentstep = 22;
      }
      if (this.delete_what == "Directgenerate") {
        this.submittocustomize();
      }
      if (this.delete_what == "Lowgenerate") {
        debugger;
        var temp = JSON.parse(JSON.stringify(this.skill));
        var temp1 = JSON.parse(JSON.stringify(this.ext_skill));
        for (let i = 0; i < temp1.length; i++) {
          if (temp.indexOf(temp1[i]) == -1) {
            temp.push(temp1[i]);
          }
        }
        this.genSkill_list = [];
        this.genSumm_list = [];
        this.genJobtitle_list = [];
        var skilljson = {
          old: this.skill,
          new: temp
        };
        this.genSkill_list.push(skilljson);

        this.skill = temp;

        var summjson = {
          old: this.summary,
          new: this.ext_summary,
          isregen: false
        };
        this.genSumm_list.push(summjson);
        var jobtitlejson = {
          old: this.Profession,
          new: this.ext_Profession
        };
        this.genJobtitle_list.push(jobtitlejson);
        // this.skill = this.ext_skill;
        this.summary = this.ext_summary;
        this.Profession = this.ext_Profession;
        this.Once_generate = true;
        this.showselectedcv();
      }
      if (this.delete_what == "CVJDMatch") {
        this.currentstep = 23;
      }
    },
    SummaryRegeneration() {
      var cv = JSON.parse(localStorage.getItem("cv_package"));
      var number = parseInt(cv.maxNoCvGenerate) - parseInt(cv.usedNoCvGenerate);
      this.actionMsg =
        "Do you want to use 1 credit out of remaining " +
        number +
        " credit(s)?";
      this.delete_what = "Regenerate";
      this.showCnfrmPopUp = true;
    },
    aigeneratedprompt() {
      $("#aigeneratedprompt").modal("show");
    },
    Changetemplateprompt() {
      $("#ChnageTemplate").modal("show");
    },
    DirectGeneration() {
      var cv = JSON.parse(localStorage.getItem("cv_package"));
      var number = parseInt(cv.maxNoCvGenerate) - parseInt(cv.usedNoCvGenerate);
      this.actionMsg =
        "Do you want to use 1 credit out of remaining " +
        number +
        " credit(s)?";
      this.delete_what = "Directgenerate";
      this.showCnfrmPopUp = true;
    },
    FirstGeneration() {
      var cv = JSON.parse(localStorage.getItem("cv_package"));
      var number = parseInt(cv.maxNoCvGenerate) - parseInt(cv.usedNoCvGenerate);
      this.actionMsg =
        "Do you want to use 1 credit out of remaining " +
        number +
        " credit(s)?";
      this.delete_what = "Generate";
      this.showCnfrmPopUp = true;
    },
    CVjdMatch() {
      var cv = JSON.parse(localStorage.getItem("cvjd_package"));
      var number = parseInt(cv.maxNocvjdMatch) - parseInt(cv.usedNoCvjdMatch);
      this.actionMsg =
        "Do you want to use 1 credit out of remaining " +
        number +
        " credit(s)?";
      this.delete_what = "CVJDMatch";
      this.showCnfrmPopUp = true;
    },
    LowGeneration() {
      this.actionMsg =
        "Your CV and JD match is very poor. Proceeding further may distort your cv. Do you want to proceed?";
      this.delete_what = "Lowgenerate";
      this.showCnfrmPopUp = true;
    },
    removeEducation(index) {
      this.actionMsg = "Do you want to remove this education detail?";
      this.delete_what = "Education";
      this.what_index = index;
      this.showCnfrmPopUp = true;
    },
    removeWork(index) {
      this.actionMsg = "Do you want to remove this work experience detail?";
      this.delete_what = "Work";
      this.what_index = index;
      this.showCnfrmPopUp = true;
      // this.work.splice(index, 1);
    },
    validateprofile() {
      this.err_name = false;
      var check = false;
      if (this.First_Name == "") {
        this.err_name = true;
        check = true;
      }
      if (this.Profession == "") {
        this.err_prof = true;
        check = true;
      }
      if (this.Phone != "") {
        if (this.Phone.length < 10) {
          this.err_phone = true;
          check = true;
        }
      }
      if (this.EmailCheck()) {
        check = true;
      }
      return check;
    },
    EmailCheck() {
      if (this.Email != "") {
        if (!this.validateEmail(this.Email)) {
          this.err_email_regex = true;
          return true;
        } else {
          this.err_email_regex = false;
          return false;
        }
      } else {
        this.err_email_regex = true;
        return true;
      }
    },
    onTagcity(new_tag) {
      this.City = new_tag;
    },
    onTagtitle(event) {
      this.Job_Title = event;
      this.filterName = event;
    },
    validateEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var re2 = re.test(email);
      return re2;
    },
    removeyourown(index) {
      this.add_your_own_json.splice(index, 1);
      this.showselectedcv();
    },
    Addyourown() {
      if (this.isown) {
        if (this.add_your_own_json.length > 0) {
          // this.add_your_own_json.forEach(o=>{
          //   if(o.title==''){
          //   }
          // })
        }
        this.own_id = this.own_id + 1;
        var own = { title: "", body: "", id: this.own_id };
        this.add_your_own_json.push(own);
      }
    },
    parseDate(dateString) {
      if (
        dateString == "" ||
        dateString == "Current" ||
        dateString == "Present"
      ) {
        return 0;
      } else {
        const parts = dateString.split("/");
        if (parts.length === 3) {
          // Format is dd/mm/yyyy
          return 3;
        } else if (parts.length === 2) {
          // Format is mm/yyyy
          return 2;
        }
      }
    },
    validateKeyPress(event) {
      debugger;
      event = event ? event : window.event;
      // Get the keycode of the pressed key
      const keyCode = event.keyCode || event.which;

      // Allow letters (a-z and A-Z) and space (keycode 32)
      if (event.currentTarget._value.length >= 200) {
        event.preventDefault();
      } else if (
        (keyCode >= 65 && keyCode <= 90) || // Uppercase letters
        (keyCode >= 97 && keyCode <= 122) || // Lowercase letters
        keyCode === 32
      ) {
        return true; // Allow the key press
      } else {
        event.preventDefault(); // Prevent any other key presses
      }
    },
    isPincode: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else if (evt.currentTarget._value.length >= 6) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else if (evt.currentTarget._value.length >= 10) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    populatecitycountry() {
      var self = this;
      var urls =
        "https://maps.googleapis.com/maps/api/geocode/json?address=" +
        this.Pin_code +
        "&key=AIzaSyCI9dR-Xj_nDADm1U_3-v8dzOAJDzkgpRQ";
      Axios({
        method: "get",
        // url: rest_service.PythonAPI + "/search",
        url: urls,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      })
        .then(function(response) {
          if (response.data) {
            const data = response.data;
            if (data.results.length > 0) {
              self.cities = data.results[0].postcode_localities;
              const addressComponents = data.results[0].address_components;
              self.City = addressComponents.find(component =>
                component.types.includes("locality")
              ).long_name;
              self.Country = addressComponents.find(component =>
                component.types.includes("country")
              ).long_name;
              // Use city and country data
            } else {
              self.City = "";
              self.Country = "";
            }
          } else {
            self.City = "";
            self.Country = "";
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    getLabel(item) {
      if (item) return item.description;
      else return item;
    },
    location_selected: function(item) {
      if (item) {
        this.customer = item;
        if (this.customer != null) {
          debugger;
          this.Work_City = this.customer.structured_formatting.main_text;
          this.Work_Country = this.customer.terms[
            this.customer.terms.length - 1
          ].value;
          this.showselectedcv();
        }
      }
    },
    location_ED_selected: function(item) {
      if (item) {
        this.customer_ed = item;
        if (this.customer_ed != null) {
          debugger;
          this.School_loc = this.customer_ed.description;
          this.showselectedcv();
          // this.Work_Country = this.customer_ed.terms[
          //   this.customer_ed.terms.length - 1
          // ].value;
        }
      }
    },
    updateItems(text) {
      if (text) {
        var self = this;
        debugger;
        Axios({
          method: "get",
          url: rest_service.baseURL + "/Anonymous/getgoogleplaces",
          // url: "https://localhost:7101/api/Anonymous/getgoogleplaces",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          params: {
            searchtext: text
          }
        })
          .then(function(response) {
            if (response) {
              self.customers = [];
              debugger;
              var converttojson = response.data.result;
              const parsed = JSON.parse(converttojson);
              var filtered_map_locations = parsed.predictions.filter(item => {
                return { description: item.description };
              });
              if (filtered_map_locations.length > 0) {
                self.customers = filtered_map_locations;
              }
            } else {
            }
          })
          .catch(function(error) {
            console.log(error);
            return error;
          });
      }
    },
    GradStartDateChange() {
      $("#gradstart_date_selected").addClass("t-valid");
      if (document.getElementById("div_gradfrom_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          altFormat: "m/Y",
          //dateFormat: "d/m/Y",
          dateFormat: "m/Y", // Month and year format
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_gradfrom_date_id"), config);
      }
      if (document.getElementById("div_gradend_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          minDate: document.getElementById("gradstart_date_id").value,
          altFormat: "m/Y",
          //dateFormat: "d/m/Y",
          dateFormat: "m/Y", // Month and year format

          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_gradend_date_id"), config);

        this.verifyeddate_mmyyyy();

        this.start_date_message = null;
      }
    },
    GradStartDateChange_withdd() {
      $("#gradstart_date_selected").addClass("t-valid");
      if (document.getElementById("div_gradfrom_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          altFormat: "d/m/Y",
          dateFormat: "d/m/Y",
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_gradfrom_date_id"), config);
      }
      if (document.getElementById("div_gradend_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          minDate: document.getElementById("gradstart_date_id").value,
          altFormat: "d/m/Y",
          dateFormat: "d/m/Y",

          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_gradend_date_id"), config);
      }
      this.verifyeddate();
    },
    StartDateChange_withdd() {
      $("#start_date_selected").addClass("t-valid");
      if (document.getElementById("div_from_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          altFormat: "d/m/Y",
          dateFormat: "d/m/Y",
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_from_date_id"), config);
      }
      if (document.getElementById("div_end_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          minDate: document.getElementById("start_date_id").value,
          altFormat: "d/m/Y",
          dateFormat: "d/m/Y",
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_end_date_id"), config);
      }
      this.verifywork_date();
    },
    StartDateChange() {
      debugger;
      $("#start_date_selected").addClass("t-valid");
      if (document.getElementById("div_from_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          altFormat: "m/Y",
          // dateFormat: "d/m/Y",
          mode: "single",
          dateFormat: "m/Y", // Month and year format
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_from_date_id"), config);
      }
      if (document.getElementById("div_end_date_id")) {
        var config = {
          locale: null,
          maxDate: "today",
          altInput: true,
          minDate: document.getElementById("start_date_id").value,
          altFormat: "m/Y",
          // dateFormat: "d/m/Y",
          dateFormat: "m/Y", // Month and year format
          from: null,
          to: null,
          wrap: true
        };
        flatpickr(document.getElementById("div_end_date_id"), config);
      }
      this.verifyworkdate_mmyyyy();
      this.start_date_message = null;
    },

    EndDateChange() {
      if (this.currentstep == 2) {
        $("#end_date_selected").addClass("t-valid");
        this.end_date_message = null;
      }
    },
    gradEndDateChange() {
      if (this.currentstep == 5) {
        $("#gradend_date_selected").addClass("t-valid");
        this.end_date_message = null;
      }
    },

    editwork(index, item) {
      this.indexToUpdate = index;
      const objectToUpdate = this.work[this.indexToUpdate];
      this.Work_City = objectToUpdate.city;
      this.Work_Country = objectToUpdate.country;
      this.End_Date = objectToUpdate.enddate;
      if (this.End_Date == "Present" || this.End_Date == "Current") {
        this.currentwork = true;
      } else {
        this.currentwork = false;
      }
      var format = this.parseDate(objectToUpdate.startdate);
      if (format == 2) {
        this.mmyyyy = true;
      }
      this.Employer = objectToUpdate.employer;
      this.Job_Title = objectToUpdate.jobtitle;
      this.Start_Date = objectToUpdate.startdate;
      this.description = objectToUpdate.description;
      this.customer = {
        description: objectToUpdate.city,
        matched_substrings: [{ length: 3, offset: 0 }],
        place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
        reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
        structured_formatting: {
          main_text: objectToUpdate.city,
          main_text_matched_substrings: [{ length: 3, offset: 0 }],
          secondary_text: "Bengaluru, Karnataka, India"
        },
        terms: [
          { offset: 0, value: "Yelahanka" },
          { offset: 11, value: "Bengaluru" },
          { offset: 22, value: "Karnataka" },
          { offset: 33, value: objectToUpdate.country }
        ],
        types: ["sublocality_level_1", "sublocality", "political", "geocode"]
      };
    },
    editworkv1(index, item) {
      this.indexToUpdate = index;
      const objectToUpdate = this.work[this.indexToUpdate];
      this.Work_City = objectToUpdate.city;
      this.Work_Country = objectToUpdate.country;
      this.End_Date = objectToUpdate.enddate;
      if (this.End_Date == "Present" || this.End_Date == "Current") {
        this.currentwork = true;
      } else {
        this.currentwork = false;
      }
      var format = this.parseDate(objectToUpdate.startdate);
      if (format == 2) {
        this.mmyyyy = true;
      }
      this.Employer = objectToUpdate.employer;
      this.Job_Title = objectToUpdate.jobtitle;
      this.Start_Date = objectToUpdate.startdate;
      this.description = objectToUpdate.description;
      this.customer = {
        description: objectToUpdate.city,
        matched_substrings: [{ length: 3, offset: 0 }],
        place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
        reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
        structured_formatting: {
          main_text: objectToUpdate.city,
          main_text_matched_substrings: [{ length: 3, offset: 0 }],
          secondary_text: "Bengaluru, Karnataka, India"
        },
        terms: [
          { offset: 0, value: "Yelahanka" },
          { offset: 11, value: "Bengaluru" },
          { offset: 22, value: "Karnataka" },
          { offset: 33, value: objectToUpdate.country }
        ],
        types: ["sublocality_level_1", "sublocality", "political", "geocode"]
      };
      this.Add_work = true;
      this.currentstep = this.currentstep - 2;
    },
    editeducation(index, item) {
      this.indexToEDUpdate = index;
      const objectToUpdate = this.Education[this.indexToEDUpdate];
      this.School_loc = objectToUpdate.school_location;
      this.School_name = objectToUpdate.school_name;
      var format = this.parseDate(objectToUpdate.grad_startdate);
      if (format == 2) {
        this.grad_mmyyyy = true;
      }
      this.Grad_Enddate = objectToUpdate.grad_enddate;
      if (this.Grad_Enddate == "Present" || this.Grad_Enddate == "Current") {
        this.currentstudy = true;
      } else {
        this.currentstudy = false;
      }
      this.Field_study = objectToUpdate.field;
      this.Grad_startdate = objectToUpdate.grad_startdate;
      this.School_desc = objectToUpdate.description;
      this.School_degree = objectToUpdate.degree;
      this.customer_ed = {
        description: objectToUpdate.school_location,
        matched_substrings: [{ length: 3, offset: 0 }],
        place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
        reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
        structured_formatting: {
          main_text: "Yelahanka",
          main_text_matched_substrings: [{ length: 3, offset: 0 }],
          secondary_text: "Bengaluru, Karnataka, India"
        },
        terms: [
          { offset: 0, value: "Yelahanka" },
          { offset: 11, value: "Bengaluru" },
          { offset: 22, value: "Karnataka" },
          { offset: 33, value: "India" }
        ],
        types: ["sublocality_level_1", "sublocality", "political", "geocode"]
      };
    },
    editeducationv1(index, item) {
      this.indexToEDUpdate = index;
      const objectToUpdate = this.Education[this.indexToEDUpdate];
      this.School_loc = objectToUpdate.school_location;
      this.School_name = objectToUpdate.school_name;
      var format = this.parseDate(objectToUpdate.grad_startdate);
      if (format == 2) {
        this.grad_mmyyyy = true;
      }
      this.Grad_Enddate = objectToUpdate.grad_enddate;

      if (this.Grad_Enddate == "Present" || this.Grad_Enddate == "Current") {
        this.currentstudy = true;
      } else {
        this.currentstudy = false;
      }
      this.Field_study = objectToUpdate.field;
      this.Grad_startdate = objectToUpdate.grad_startdate;
      this.School_desc = objectToUpdate.description;
      this.School_degree = objectToUpdate.degree;
      this.customer_ed = {
        description: objectToUpdate.school_location,
        matched_substrings: [{ length: 3, offset: 0 }],
        place_id: "ChIJ1dI391YYrjsRL5RdGCCN974",
        reference: "ChIJ1dI391YYrjsRL5RdGCCN974",
        structured_formatting: {
          main_text: "Yelahanka",
          main_text_matched_substrings: [{ length: 3, offset: 0 }],
          secondary_text: "Bengaluru, Karnataka, India"
        },
        terms: [
          { offset: 0, value: "Yelahanka" },
          { offset: 11, value: "Bengaluru" },
          { offset: 22, value: "Karnataka" },
          { offset: 33, value: "India" }
        ],
        types: ["sublocality_level_1", "sublocality", "political", "geocode"]
      };
      this.Add_ed = true;
      this.currentstep = 5;
    },
    closeMessage() {
      this.isdisplaymsg = false;
      // this.iserrormsg = false;
    },
    Addnew() {
      this.Work_City = "";
      this.Work_Country = "";
      this.End_Date = "";
      this.currentwork = false;
      this.Employer = "";
      this.Job_Title = "";
      this.Start_Date = "";
      this.description = "";
      this.customer = null;
      this.Work_id = this.work.length;

      var workobj = {
        id: this.Work_id,
        city: this.Work_City,
        country: this.Work_Country,
        enddate: this.End_Date,
        employer: this.Employer,
        jobtitle: this.Job_Title,
        startdate: this.Start_Date,
        description: this.description
      };
      this.work.push(workobj);
      this.Add_work = true;
      this.indexToUpdate = this.work.length - 1;
      this.currentstep = 2;
    },
    ReverseWork() {
      debugger;
      var revarray = this.work.reverse();
    },
    AddnewEd() {
      this.School_loc = "";
      this.School_name = "";
      this.School_degree = "";
      this.Field_study = "";
      this.Grad_startdate = "";
      this.Grad_Enddate = "";
      this.currentstudy = false;
      this.School_desc = "";
      this.customer_ed = null;
      this.Ed_id = this.Education.length;
      var edobj = {
        id: this.Ed_id,
        field: this.Field_study,
        degree: this.School_degree,
        grad_startdate: this.Grad_startdate,
        school_name: this.School_name,
        grad_enddate: this.Grad_Enddate,
        description: this.School_desc,
        school_location: this.School_loc
      };
      this.Education.push(edobj);
      this.indexToEDUpdate = this.Education.length - 1;
      this.Add_ed = true;
      this.currentstep = 5;
    },
    Addskill(item) {
      var self = this;
      if (self.skillrepeat(item)) {
        self.removeskillrepeat(item);
      } else {
        var skilljson = {
          text: item,
          rate: 0
        };
        self.skill.push(skilljson);
      }

      // if (self.skill.includes(item)) {
      //   self.skill = self.skill.replace(item, "").trim();
      // } else {
      //   self.skill = self.skill + "\u2022" + item;
      // }
    },
    Addaccomplish(item) {
      var self = this;
      if (self.accomplishments.includes(item)) {
        // self.opeining =self.opeining+ item;
        self.accomplishments = self.accomplishments.replace(item, "").trim();
      } else {
        self.accomplishments = self.accomplishments + "\u2022" + item;
      }
    },
    Addsummary(item) {
      var self = this;
      if (self.summary.includes(item)) {
        // self.opeining =self.opeining+ item;
        self.summary = self.summary.replace(item, "").trim();
      } else {
        self.summary = self.summary + "\u2022" + item;
      }
    },
    Addaffiliation(item) {
      var self = this;
      if (self.affiliations.includes(item)) {
        // self.opeining =self.opeining+ item;
        self.affiliations = self.affiliations.replace(item, "").trim();
      } else {
        self.affiliations = self.affiliations + "\u2022" + item;
      }
    },
    addworkdesc(item) {
      var self = this;
      if (self.description.includes(item)) {
        // self.opeining =self.opeining+ item;
        self.description = self.description.replace(item, "").trim();
      } else {
        self.description = self.description + "\u2022" + item;
      }
    },
    GetJobTitle() {
      debugger;

      var uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      var self = this;
      Axios({
        method: "get",
        // url: rest_service.PythonAPI + "/search",
        url: rest_service.baseURL + "/CV/GetAllJobtitle",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + uid.returnedToken
        }
      })
        .then(function(response) {
          if (response.data.result) {
            debugger;
            response.data.result.forEach(e => {
              self.jobtitlelist.push(e.title);
            });
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);

          return error;
        });
    },
    previewFiles(event) {
      debugger;
      this.isCorrupt = true;
      var self = this;
      var fileIn = event.target.files[0];
      const fileReader = new FileReader();

      fileReader.onload = () => {
        const image = new Image();

        image.onerror = () => {
          // Image failed to load or is corrupted
          console.log("The selected image is corrupted.");
          self.isCorrupt = false;
          $("#fileUpload").val("");
          return prevent();
          //alert("corrupted");
        };

        image.onload = () => {
          // Image loaded successfully
          console.log("The selected image is valid.");
        };

        image.src = fileReader.result;
      };

      fileReader.readAsDataURL(fileIn);
      self.validateFile();
      if (self.isCorrupt) {
        var file = event.target.files[0];
        if (file) {
          let reader = new FileReader();
          reader.onload = function(event) {
            $("#imgPreview").attr("src", event.target.result);
            self.showselectedcv();
          };
          reader.readAsDataURL(file);
        }
      }
    },
    validateFile() {
      var fileName = document.getElementById("fileUpload").value;
      var dot = fileName.lastIndexOf(".") + 1;
      var extFile = fileName.substr(dot, fileName.length).toLowerCase();
      var tempFiles1 = document.getElementById("fileUpload").files;
      if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(fileName)) {
        $("#fileUpload").val("");
        return prevent();
      }
      //alert(this.fileCount > this.$store.state.helper.allowedFileSize? "larger":"smaller");
    },
    GetJobdesc(item) {
      debugger;
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/job_description",
        //url: "https://resumebuilder.careercubicle.com/job_description",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            debugger;
            self.WorkDesc = response.data;
            var dataToStore = JSON.stringify(response.data);
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    getSummary(item) {
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/search_summary",
        //url: "https://resumebuilder.careercubicle.com" + "/search_summary",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            debugger;
            self.Summary_list = response.data;
            var dataToStore = JSON.stringify(response.data);
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    getSkilllist(item) {
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/search_skills",
        //url: "https://resumebuilder.careercubicle.com" + "/search_skills",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            debugger;
            self.Skill_list = response.data;
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    getAccomplish(item) {
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/accomplishments",
        //url: "https://resumebuilder.careercubicle.com" + "/accomplishments",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            debugger;
            self.acc_list = response.data;
            var dataToStore = JSON.stringify(response.data);
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    getAffiliate(item) {
      var self = this;
      Axios({
        method: "get",
         url: rest_service.PythonAPI + "/affiliation",
       // url: "https://resumebuilder.careercubicle.com" + "/affiliation",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        params: {
          job_title: item
        }
      })
        .then(function(response) {
          if (response.data) {
            debugger;
            self.aff_list = response.data;
            var dataToStore = JSON.stringify(response.data);
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    Saveresume() {
      this.previewResume();
      if (this.template_name == "resume1.png") {
        this.$refs.resumeone.saveResume();
      }
      if (this.template_name == "resume2.png") {
        this.$refs.resumetwo.saveResume();
      }
      if (this.template_name == "resume3.png") {
        this.$refs.resumethree.saveResume();
      }
      if (this.template_name == "resume4.png") {
        this.$refs.resumefour.saveResume();
      }
      if (this.template_name == "resume5.png") {
        this.$refs.resumefive.saveResume();
      }
      if (this.template_name == "resume6.png") {
        this.$refs.resumesix.saveResume();
      }
      if (this.template_name == "resume7.png") {
        this.$refs.resumeseven.saveResume();
      }
      if (this.template_name == "resume8.png") {
        this.$refs.resumeeight.saveResume();
      }
      if (this.template_name == "resume9.png") {
        this.$refs.resumenine.saveResume();
      }
      if (this.template_name == "resume10.png") {
        this.$refs.resumetwelve.saveResume();
      }
    },
    previewResumeone() {
      this.previewResume();
      if (this.template_name == "resume1.png") $("#resumeprompt").modal("show");
      if (this.template_name == "resume2.png")
        $("#resumetwoprompt").modal("show");
      if (this.template_name == "resume3.png")
        $("#resumethreeprompt").modal("show");
      if (this.template_name == "resume4.png")
        $("#resumefourprompt").modal("show");
      if (this.template_name == "resume5.png")
        $("#resumefiveprompt").modal("show");
      if (this.template_name == "resume6.png")
        $("#resumesixprompt").modal("show");
      if (this.template_name == "resume7.png")
        $("#resumesevenprompt").modal("show");
      if (this.template_name == "resume8.png")
        $("#resumeeightprompt").modal("show");
      if (this.template_name == "resume9.png")
        $("#resumenineprompt").modal("show");
        if (this.template_name == "resume10.png")
        $("#resumetwelveprompt").modal("show");
    },
    Handlecarousel(item) {
      this.template_name = item.name;
      this.showselectedcv();
      this.opencarousel = false;
    },
    HandleTemplatechange() {
      if(this.popupresume==1){
        this.template_name = "resume1.png";
      }
      if(this.popupresume==2){
        this.template_name = "resume2.png";
      }
      if(this.popupresume==3){
        this.template_name = "resume3.png";
      }
      if(this.popupresume==4){
        this.template_name = "resume4.png";
      }
      if(this.popupresume==5){
        this.template_name = "resume5.png";
      }
      if(this.popupresume==6){
        this.template_name = "resume6.png";
      }
      if(this.popupresume==7){
        this.template_name = "resume7.png";
      }
      if(this.popupresume==8){
        this.template_name = "resume8.png";
      }
      if(this.popupresume==9){
        this.template_name = "resume9.png";
      }
      if(this.popupresume==12){
        this.template_name = "resume10.png";
      }
      if(this.hoveredColor =="" ){
        this.hoveredColor = this.previousColor;
      }
      this.showselectedcv();
      this.previousColor=this.hoveredColor ;
      $("#ChnageTemplate").modal("hide");
    },
    CancelTemplatechange(){
      this.hoveredColor = this.previousColor;
      this.showselectedcv();
      $("#ChnageTemplate").modal("hide");
    },
    showselectedcv() {
      this.previewResume();
      if (this.template_name == "resume1.png") {
        this.showResume = true;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
        this.popupresume = 1;
      }
      if (this.template_name == "resume2.png") {
        this.showResume = false;
        this.showResumetwo = true;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
        this.popupresume = 2;
      }
      if (this.template_name == "resume3.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = true;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
        this.popupresume = 3;
      }
      if (this.template_name == "resume4.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = true;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
        this.popupresume = 4;
      }
      if (this.template_name == "resume5.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = true;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
        this.popupresume = 5;
      }
      if (this.template_name == "resume6.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = true;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
        this.popupresume = 6;
      }
      if (this.template_name == "resume7.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = true;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = false;
        this.popupresume = 7;
      }
      if (this.template_name == "resume8.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = true;
        this.showResumenine = false;
        this.showResumetwelve = false;
        this.popupresume = 8;
      }
      if (this.template_name == "resume9.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = true;
        this.showResumetwelve = false;
        this.popupresume = 9;
      }
      if (this.template_name == "resume10.png") {
        this.showResume = false;
        this.showResumetwo = false;
        this.showResumethree = false;
        this.showResumefour = false;
        this.showResumefive = false;
        this.showResumesix = false;
        this.showResumeseven = false;
        this.showResumeeight = false;
        this.showResumenine = false;
        this.showResumetwelve = true;
        this.popupresume = 12;
      }
    },
    removeSpecialCharacters(str) {
      // Regular expression to remove special characters except letters, numbers, and spaces
      return str.replace(/[^\w\s]/gi, '').replace(/\s+/g, '');

    },
    previewResume() {
      var temp_resumeobj = {};
      temp_resumeobj.profile = {};
      temp_resumeobj.profile.firstname = this.First_Name;
      temp_resumeobj.profile.surname = this.Last_Name;
      temp_resumeobj.profile.email = this.Email;
      temp_resumeobj.profile.pincode = this.Pin_code;
      temp_resumeobj.profile.profession = this.Profession;
      temp_resumeobj.profile.country = this.Country;
      temp_resumeobj.profile.city = this.City;
      temp_resumeobj.profile.phone = this.Phone;
      temp_resumeobj.profile.linkedin = this.Linkedin;
      temp_resumeobj.profile.website = this.Website;
      temp_resumeobj.profile.twitter = this.Twitter;
      temp_resumeobj.profile.address = this.Address;
      temp_resumeobj.profile.color = this.hoveredColor;
      temp_resumeobj.color = this.hoveredColor;
      if (this.currentstep == 2 || this.currentstep == 3) {
        if (this.work.length > 0) {
          const objectToUpdate = this.work[this.indexToUpdate];
          objectToUpdate.city = this.Work_City;
          objectToUpdate.country = this.Work_Country;
          objectToUpdate.enddate = this.End_Date;
          objectToUpdate.startdate = this.Start_Date;
          objectToUpdate.employer = this.Employer;
          objectToUpdate.jobtitle = this.Job_Title;
          objectToUpdate.description = this.description;
        }
      }
      temp_resumeobj.workExperience = this.work;
      if (this.currentstep == 5) {
        if (this.Education.length > 0) {
          const objectToedUpdate = this.Education[this.indexToEDUpdate];
          objectToedUpdate.field = this.Field_study;
          objectToedUpdate.degree = this.School_degree;
          objectToedUpdate.grad_startdate = this.Grad_startdate;
          objectToedUpdate.school_name = this.School_name;
          objectToedUpdate.grad_enddate = this.Grad_Enddate;
          objectToedUpdate.description = this.School_desc;
          objectToedUpdate.school_location = this.School_loc;
        }
      }
      temp_resumeobj.education = this.Education;
      temp_resumeobj.skills = this.skill;
      temp_resumeobj.summary = this.summary;
      temp_resumeobj.Purchased_Package_id =
        "b312dc61-e17c-4f09-816f-525b3f9e744b";
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      temp_resumeobj.pic = this.temp_pic;
      temp_resumeobj.Profile_pic = this.pic;
      var acc = "None";
      var aff = "None";
      var add = "None";
      var int = "None";
      var cert = "None";
      var lang = "None";
      var soft = "None";
      if (this.accomplishments != "") {
        acc = this.accomplishments;
      }
      if (this.affiliations != "") {
        aff = this.affiliations;
      }
      if (this.additionals != "") {
        add = this.additionals;
      }
      if (this.language != "") {
        lang = this.language;
      }
      if (this.software != "") {
        soft = this.software;
      }
      if (this.intrest != "") {
        int = this.intrest;
      }
      debugger;
      if (this.certificate != "") {
        cert = this.certificate;
      }
      if (!this.isown) {
        this.add_your_own_json = [];
      }

      var Extrainfo = {
        accomplishments_text: acc,
        affiliations_text: aff,
        additional_information_text: add,
        software_text: soft,
        languages_text: lang,
        certifications_text: cert,
        interests_text: int,
        add_your_own_json: this.add_your_own_json
      };
      temp_resumeobj.extraFields = Extrainfo;
      if (this.currentstep == 17) {
        this.isfinal = true;
      }

      temp_resumeobj.UniqueId = this.Unique_id;
      temp_resumeobj.Template = this.template_name;
      temp_resumeobj.currentstep = this.currentstep;
      this.resumeobj = temp_resumeobj;
    },
    AddEddesc() {
      this.isEddesc = !this.isEddesc;
      if (this.isEddesc == true) {
        this.School_desc = "";
      }
    },
    backfromjd(item) {
      if (item == "match") {
        this.actionMsg =
          "Do you want to go back without knowing your match percentage?";
      }
      if (item == "custom") {
        this.actionMsg =
          "Do you want to go back without personalizing your cv?";
      }

      this.delete_what = "Jd";
      this.showCnfrmPopUp = true;
    },
    goback() {
      this.perfectmatch = false;
      this.Job_desc = "";
      this.currentstep = 17;
    },
    back(item) {
      if (this.currentstep == 2 || this.currentstep == 3) {
        if (this.work.length > 0 && this.work != null) {
          const objectToUpdate = this.work[this.indexToUpdate];
          objectToUpdate.city = this.Work_City;
          objectToUpdate.country = this.Work_Country;
          objectToUpdate.enddate = this.End_Date;
          objectToUpdate.startdate = this.Start_Date;
          objectToUpdate.employer = this.Employer;
          objectToUpdate.jobtitle = this.Job_Title;
          objectToUpdate.description = this.description;
        }
      }
      if (this.currentstep == 5) {
        if (this.Education.length > 0 && this.Education != null) {
          const objectToUpdate = this.Education[this.indexToEDUpdate];
          objectToUpdate.field = this.Field_study;
          objectToUpdate.degree = this.School_degree;
          objectToUpdate.grad_startdate = this.Grad_startdate;
          objectToUpdate.school_name = this.School_name;
          objectToUpdate.grad_enddate = this.Grad_Enddate;
          objectToUpdate.description = this.School_desc;
          objectToUpdate.school_location = this.School_loc;
        }
      }
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
        }
      }
      debugger;
      //this.steps = [1, 2, 3, 4, 5, 6, 7, 8, 9];
      this.steps = [1, 4, 6, 7, 8, 9];
      if (this.Add_work) {
        let index = this.steps.indexOf(4);

        this.steps.splice(index, 0, 2);
        this.steps.splice(index + 1, 0, 3);
      }
      if (this.Add_ed) {
        let index = this.steps.indexOf(6);
        this.steps.splice(index, 0, 5);
      }
      if (this.isaccomplishment) {
        this.steps.push(10);
      }
      if (this.isaffilation) {
        this.steps.push(11);
      }
      if (this.isadditional) {
        this.steps.push(12);
      }
      if (this.issoftware) {
        this.steps.push(13);
      }
      if (this.islang) {
        this.steps.push(14);
      }
      if (this.iscertificate) {
        this.steps.push(15);
      }
      if (this.isintrest) {
        this.steps.push(16);
      }
      if (this.isown) {
        this.steps.push(20);
      }
      this.steps.push(17);
      for (var i = this.steps.length; i > 0; i--) {
        if (this.steps[i] == item) {
          this.currentstep = this.steps[i - 1];
          if((i)==(this.steps.length-1)){
          this.stepname = "Next: Finalize";
        }
        else{
          this.stepname = "Save & Continue";
        }
        }
        debugger;
        
      }
      if (this.currentstep == 9) {
        this.showselectedcv();
      }
    },
    nextstep(item) {
      var check = false;
      if (this.currentstep == 2 || this.currentstep == 3) {
        if (this.work.length > 0) {
          const objectToUpdate = this.work[this.indexToUpdate];
          objectToUpdate.city = this.Work_City;
          objectToUpdate.country = this.Work_Country;
          objectToUpdate.enddate = this.End_Date;
          objectToUpdate.startdate = this.Start_Date;
          objectToUpdate.employer = this.Employer;
          objectToUpdate.jobtitle = this.Job_Title;
          objectToUpdate.description = this.description;
        }
      }
      if (this.currentstep == 5) {
        if (this.Education.length > 0) {
          const objectToUpdate = this.Education[this.indexToEDUpdate];
          objectToUpdate.field = this.Field_study;
          objectToUpdate.degree = this.School_degree;
          objectToUpdate.grad_startdate = this.Grad_startdate;
          objectToUpdate.school_name = this.School_name;
          objectToUpdate.grad_enddate = this.Grad_Enddate;
          objectToUpdate.description = this.School_desc;
          objectToUpdate.school_location = this.School_loc;
        }
      }
      if (this.currentstep == 1) {
        var updatedFile = $("#imgPreview").prop("src");
        if (updatedFile != undefined) {
          this.temp_pic = updatedFile;
          let base64encoded = updatedFile.toString();
          const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
          base64encoded = base64encoded.substring(sIndex);
          this.pic = base64encoded;
          if (this.validateprofile()) {
            check = true;
          }
        }
      }
     // this.steps = [1, 2, 3, 4, 5, 6, 7, 8, 9];
     this.steps = [1, 4, 6, 7, 8, 9];
     if (this.Add_work) {
        let index = this.steps.indexOf(4);

        this.steps.splice(index, 0, 2);
        this.steps.splice(index + 1, 0, 3);
      }
      if (this.Add_ed) {
        let index = this.steps.indexOf(6);
        this.steps.splice(index, 0, 5);
      }
      if (this.isaccomplishment) {
        this.steps.push(10);
      }
      if (this.isaffilation) {
        this.steps.push(11);
      }
      if (this.isadditional) {
        this.steps.push(12);
      }
      if (this.issoftware) {
        this.steps.push(13);
      }
      if (this.islang) {
        this.steps.push(14);
      }
      if (this.iscertificate) {
        this.steps.push(15);
      }
      if (this.isintrest) {
        this.steps.push(16);
      }
      if (this.isown) {
        this.steps.push(20);
      }
      this.steps.push(17);
      if (check == false) {
        for (var i = 0; i < this.steps.length; i++) {
          if (this.steps[i] == item) {
            if(this.steps[i + 2]==17){
              this.stepname = "Next: Finalize";
            }
            else{
              this.stepname = "Save & Continue";
            }
            this.currentstep = this.steps[i + 1];
          }
        }
      }
      if (this.currentstep == 17) {
        this.showselectedcv();
      }
    },
    replaceNumericalValuesWithText(sentence, replacetxt) {
      // Use a regular expression to find numerical values in the sentence
      const regex = /\d+/g;

      // Replace each numerical value with your desired text
      const replacedSentence = sentence.replace(regex, replacetxt);

      return replacedSentence;
    },
    tryParseDate(dateString, format) {
      try {
        // Split the date string to handle different formats
        const dateParts = dateString.split("/");
        var formattedDate;
        if (format == "DD/MM/YYYY") {
          formattedDate =
            dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
        } else if (format == "MMM YYYY") {
          formattedDate = "01" + "/" + dateParts[0] + "/" + dateParts[1];
        }
        let parsedDate = new Date(formattedDate);
        let options = {
          day: "numeric",
          month: "numeric",
          year: "numeric"
        };
        return parsedDate.toLocaleDateString("en-IN", options);
      } catch (error) {
        return null;
      }
    },
    calculateYearsDifference(startDate, endDate) {
      var startdateformat1;
      var startdateformat2;
      var enddateformat1;
      var enddateformat2;
      startdateformat1 = this.tryParseDate(startDate, "DD/MM/YYYY");
      if (
        startdateformat1 == null ||
        startdateformat1 == undefined ||
        startdateformat1 == "Invalid Date"
      ) {
        startdateformat2 = this.tryParseDate(startDate, "MMM YYYY");
      }
      if (endDate == "Current") {
        enddateformat1 = moment().format("DD/MM/YYYY");
      } else {
        enddateformat1 = this.tryParseDate(endDate, "DD/MM/YYYY");
        if (
          enddateformat1 == null ||
          enddateformat1 == undefined ||
          enddateformat1 == "Invalid Date"
        ) {
          enddateformat2 = this.tryParseDate(endDate, "MMM YYYY");
        }
      }
      var start;
      var end;
      if (
        startdateformat1 != null &&
        startdateformat1 != undefined &&
        startdateformat1 != "Invalid Date"
      ) {
        const dateParts = startdateformat1.split("/");
        var formattedDate =
          dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
        start = new Date(formattedDate);
      } else if (
        startdateformat2 != null &&
        startdateformat2 != undefined &&
        startdateformat2 != "Invalid Date"
      ) {
        const dateParts = startdateformat2.split("/");
        var formattedDate =
          dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
        start = new Date(formattedDate);
      }
      if (
        enddateformat1 != null &&
        enddateformat1 != undefined &&
        enddateformat1 != "Invalid Date"
      ) {
        const dateParts = enddateformat1.split("/");
        var formattedDate =
          dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
        end = new Date(formattedDate);
      } else if (
        enddateformat2 != null &&
        enddateformat2 != undefined &&
        enddateformat2 != "Invalid Date"
      ) {
        const dateParts = enddateformat2.split("/");
        var formattedDate =
          dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
        end = new Date(formattedDate);
      }
      const timeDiff = Math.abs(end - start);
      return timeDiff;
    },
    EditCV() {
      debugger;
      var self = this;
      var uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
      Axios({
        method: "get",
        url: rest_service.baseURL + "/CV/GetCVContent",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + uid.returnedToken
        },
        params: {
          id: self.$route.params.id
        }
      })
        .then(function(response) {
          if (response.data.result) {
            if (
              response.data.result.profilePic != null &&
              response.data.result.profilePic != ""
            ) {
              var uid = JSON.parse(localStorage.getItem("loggedinuserobj"));
              Axios({
                method: "get",
                url: rest_service.baseURL + "/S3proxy/GetAllImagebase64",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + uid.returnedToken
                },
                //IN LOCAL UNCOMMENT BELOW LINE
                responseType: "blob",

                params: {
                  id: response.data.result.profilePic
                }
              })
                .then(function(respo) {
                  if (respo) {
                    debugger;
                    //IN LOCAL UNCOMMENT
                    var reader = new FileReader();
                    reader.onload = () => {
                      const base64String = reader.result;
                      // Do something with the base64String, such as sending it to a server or using it in your application
                      console.log(base64String);
                      response.data.result.profilePic = base64String;
                      self.Binddata(response.data.result);
                    };
                    reader.readAsDataURL(respo.data);
                    //IN LOCAL UNCOMMENT
                    debugger;

                    // var base64String = "data:application/octet-stream;base64,"+ respo.data;
                    // response.data.result.profilePic = base64String;
                    //self.Binddata(response.data.result);
                  } else {
                    return null;
                  }
                })
                .catch(function(error) {
                  console.log(error);
                  return error;
                });
            } else {
              self.Binddata(response.data.result);
            }
          } else {
            return null;
          }
        })
        .catch(function(error) {
          console.log(error);
          return error;
        });
    },
    Binddata(item) {
      debugger;

      var profile = JSON.parse(item.profile);
      this.First_Name = profile.firstname;
      this.Last_Name = profile.surname;
      this.Email = profile.email;
      this.Pin_code = profile.pincode;
      this.Profession = profile.profession;
      this.Country = profile.country;
      this.City = profile.city;
      
      if (item.color != null && item.color != undefined)
        {
        this.hoveredColor = item.color;
        this.previousColor = item.color;
      }
      else{
        this.hoveredColor = "rgb(0, 151, 178)";
        this.previousColor = "rgb(0, 151, 178)";
      }
      if (
        profile.phone != null &&
        profile.phone != "" &&
        profile.phone.length >= 10
      )
        {var phonenum = this.removeSpecialCharacters(profile.phone);
              this.Phone = phonenum.substring(phonenum.length - 10);}
      this.Linkedin = profile.linkedin;
      this.Website = profile.website;
      this.Twitter = profile.twitter;
      this.Address = profile.address;
      debugger;
      this.work = JSON.parse(item.workExperience);
      if (this.work != null && this.work.length > 0) {
        this.editwork(this.indexToUpdate, this.work[this.indexToUpdate]);
      } else {
        this.work = [];
      }
      this.Education = JSON.parse(item.education);
      if (this.Education != null && this.Education.length > 0) {
        this.editeducation(
          this.indexToEDUpdate,
          this.Education[this.indexToEDUpdate]
        );
      } else {
        this.Education = [];
      }
      debugger;
      if (item.skills != null && item.skills != undefined) {
        var skillval = JSON.parse(item.skills);
        var type = typeof skillval;
        if (type != "string") {
          this.skill = JSON.parse(item.skills);
        } else {
        
          this.skill = JSON.parse(skillval);
         // this.skill = [];
        }
      } else this.skill = "";
      if (item.summary != null && item.summary != undefined)
        this.summary = item.summary;
      else this.summary = "";
      
      if (localStorage.getItem("cv_generation")) {
        var Content = JSON.parse(localStorage.getItem("cv_generation"));
        var temp = JSON.parse(JSON.stringify(this.skill));
        var temp1 = Content.skills;
        temp.push(temp1);
        var newskill = temp;
        var skilljson = {
          old: this.skill,
          new: newskill
        };
        this.genSkill_list.push(skilljson);
        var summjson = {
          old: this.summary,
          new: Content.summary,
          isregen: false
        };
        this.genSumm_list.push(summjson);
        var jobtitlejson = {
          old: this.Profession,
          new: Content.jobtitle
        };
        this.genJobtitle_list.push(jobtitlejson);
        const array = Content.skills.split(",");
        array.forEach(item => {
          if (!this.skillrepeat(item)) {
            var skill_json = {
              text: item,
              rate: 0
            };
            this.skill.push(skill_json);
          }
        });
        this.summary = Content.summary;
        this.Profession = Content.jobtitle;
        this.Once_generate = true;
        localStorage.removeItem("cv_generation");
      }
      var Extrainfo = JSON.parse(item.extraFields);
      this.Unique_id = item.uniqueId;

      if (Extrainfo.accomplishments_text != "None") {
        this.isaccomplishment = true;
        this.accomplishments = Extrainfo.accomplishments_text;
      }
      if (Extrainfo.software_text != "None") {
        this.issoftware = true;
        this.software = Extrainfo.software_text;
      }
      if (Extrainfo.interests_text != "None") {
        this.isintrest = true;
        this.intrest = Extrainfo.interests_text;
      }
      if (Extrainfo.languages_text != "None") {
        this.islang = true;
        this.language = Extrainfo.languages_text;
      }

      if (Extrainfo.affiliations_text != "None") {
        this.isaffilation = true;
        this.affiliations = Extrainfo.affiliations_text;
      }
      if (Extrainfo.certifications_text != "None") {
        this.iscertificate = true;
        this.certificate = Extrainfo.certifications_text;
      }
      if (Extrainfo.additional_information_text != "None") {
        this.isadditional = true;
        this.additionals = Extrainfo.additional_information_text;
      }
      debugger;
      var parsed_own_json = Extrainfo.add_your_own_json;
      if (parsed_own_json != "None") {
        // var parsed_own_json = JSON.parse(parsed_own);
        if (parsed_own_json.length > 0) {
          this.isown = true;
          this.add_your_own_json = parsed_own_json;
          this.own_id = parsed_own_json.length + 1;
        }
      }
      debugger;
      if (item.profilePic != null && item.profilePic != "") {
        this.temp_pic = item.profilePic;
      }
      let base64encoded = this.temp_pic.toString();
      const sIndex = base64encoded.indexOf(";") + "base64,".length + 1;
      base64encoded = base64encoded.substring(sIndex);
      this.pic = base64encoded;
      if (item.template) this.template_name = item.template;
    },
    skillrepeat(item) {
      var found = false;

      if (this.skill.length > 0) {
        this.skill.forEach(t => {
          if (t.text.includes(item)) {
            found = true;
            return;
          }
        });
      }
      return found;
    },
    removeskillrepeat(attr) {
      var i = this.skill.length;
      while (i--) {
        if (this.skill[i] && this.skill[i].text.includes(attr)) {
          this.skill.splice(i, 1);
        }
      }
    }
  },
  watch: {
    currentstudy(val) {
      if (this.currentstudy) {
        this.Grad_Enddate = "Current";
      } else {
        this.Grad_Enddate = "";
      }
    },
    currentwork(val) {
      if (this.currentwork) {
        this.End_Date = "Current";
      } else {
        this.End_Date = "";
      }
    },
    Job_Title(val) {
      this.filterName = this.Job_Title;
      this.showselectedcv();
    },
    filterName(val) {
      this.GetJobdesc(this.filterName);
      this.getSkilllist(this.filterName);
      this.getSummary(this.filterName);
      this.getAccomplish(this.filterName);
      this.getAffiliate(this.filterName);
    },
    Job_desc(val) {
      if (this.Job_desc != "") this.err_jd = false;
    },
    skill(val) {
      this.showselectedcv();
    },
    summary(val) {
      this.showselectedcv();
    },
    mmyyyy(val) {
      if (this.mmyyyy) {
        if(this.End_Date!=''&&this.End_Date!=null&&this.End_Date!='Current'){
          var part = this.End_Date.split('/');
          var date = part[1]+'/'+part[2];
          this.End_Date=date;
        }
        if(this.Start_Date!=''&&this.Start_Date!=null){
          var part = this.Start_Date.split('/');
          var date = part[1]+'/'+part[2];
          this.Start_Date=date;
        }
        
      }
      else{
        if(this.End_Date!=''&&this.End_Date!=null&&this.End_Date!='Current'){
          var part = this.End_Date.split('/');
          var date = '01/'+part[0]+'/'+part[1];
          this.End_Date=date;
        }
        if(this.Start_Date!=''&&this.Start_Date!=null){
          var part = this.Start_Date.split('/');
          var date = '01/'+part[0]+'/'+part[1];
          this.Start_Date=date;
        }
      }
    },
    grad_mmyyyy(val) {
      if (this.grad_mmyyyy) {
        if(this.Grad_Enddate!=''&&this.Grad_Enddate!=null&&this.Grad_Enddate!='Current'){
          var part = this.Grad_Enddate.split('/');
          var date = part[1]+'/'+part[2];
          this.Grad_Enddate=date;
        }
        if(this.Grad_startdate!=''&&this.Grad_startdate!=null){
          var part = this.Grad_startdate.split('/');
          var date = part[1]+'/'+part[2];
          this.Grad_startdate=date;
        }
        
      }
      else{
        if(this.Grad_Enddate!=''&&this.Grad_Enddate!=null&&this.Grad_Enddate!='Current'){
          var part = this.Grad_Enddate.split('/');
          var date = '01/'+part[0]+'/'+part[1];
          this.Grad_Enddate=date;
        }
        if(this.Grad_startdate!=''&&this.Grad_startdate!=null){
          var part = this.Grad_startdate.split('/');
          var date = '01/'+part[0]+'/'+part[1];
          this.Grad_startdate=date;
        }
      }
    },
    School_desc(val) {
      this.showselectedcv();
    },
    Start_Date(val) {
      this.showselectedcv();
    },
    End_Date(val) {
      this.showselectedcv();
    },
    Grad_Enddate(val) {
      this.showselectedcv();
    },
    Grad_startdate(val) {
      this.showselectedcv();
    },
    template_name(val) {
      if (this.currentstep == 17) {
        this.showselectedcv();
      }
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
h3 {
  font-size: 24px;
  font-weight: 700;
}

.btn-primary.preview {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff !important;
  max-width: 181px;
  margin: 0 auto 10px;
}

.btn-primary.preview i.material-icons {
  font-size: 16px;
  margin-right: 5px;
}

.btn-primary.preview:hover {
  color: #1f85cd;
}

.resume-builder-main .resume-builder-right .btn-sec a {
  padding: 4px 25px;
  line-height: 35px;
  font-size: 15px;
}

.resume-builder-main .resume-builder-right .btn-sec a.btn-primary {
  color: #fff;
  cursor: pointer;
}

.resume-builder-main .resume-builder-right .btn-sec a.btn-primary:hover {
  color: #1f85cd;
}

.resume-builder-main .resume-builder-right .btn-sec {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 0;
  background: #fff;
  padding: 15px 50px;
  width: 100%;
  left: 0;
  box-shadow: 2px -2px 2px rgba(0, 0, 0, 0.16);
  min-height: 113px;
  z-index: 1;
}
.TemplateBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.TemplateBtn img {
  display: none;
}

.TemplateBtn span {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1f85cd;
  font-weight: 600;
  border: 2px dashed transparent;
  padding: 10px 20px;
  border-radius: 30px;
}
.TemplateBtn span:hover {
  border: 2px dashed #1f85cd;
}
.TemplateBtn span i {
  display: none;
}

.resume-builder-main {
  padding-bottom: 110px;
}

.ready-use-scroll {
  max-height: 280px;
  overflow: auto;
}

.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .ready-use-example
  .box
  a {
  margin-left: 10px;
}

.details-fill-box {
  position: relative;
}

.details-fill-box a.edit-icon {
  color: #1f85cd;
  font-weight: 500;
  cursor: pointer;
}

.details-fill-box a.edit-icon i {
  font-size: 16px;
}

.details-fill-box > div {
  margin-bottom: 10px;
}

.details-fill-box > div strong {
  font-weight: 600;
  margin-right: 5px;
  min-width: 150px;
  display: inline-block;
}

.details-fill-box .resume-btn-sec {
  display: flex;
  justify-content: flex-end;
  color: #fff;
}

.details-fill-box .resume-btn-sec a:hover {
  color: #1f85cd !important;
}

.custom-column {
  padding-right: 15px;
  padding-left: 15px;
  max-width: 50%;
  width: 100%;
}

.resume-btn-sec a.btn-primary {
  color: #fff;
}

.resume-btn-sec a.btn-primary:hover {
  color: #1f85cd;
}

.details-fill-box .fill-box-button {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.details-fill-box .fill-box-button a {
  background: #ddd;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 5px;
}
.details-fill-box .fill-box-button a:hover {
  color: #000;
}

.resume-builder-main
  .resume-builder-right
  .content
  .form-section
  .left-form
  .add-social-links
  span {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.resume-desc-sec .btn-primary.md-ink-ripple {
  color: #fff;
  margin-bottom: 10px;
}

.resume-desc-sec .btn-primary.md-ink-ripple:hover {
  color: #1f85cd;
}

.resume-desc-sec {
  text-align: center;
  margin-top: 30px;
}

.job-desc {
  max-width: 700px;
  margin: 50px auto;
  width: 100%;
}

.job-desc textarea {
  width: 100%;
  max-height: 200px;
  height: 100% !important;
  min-height: 150px;
  margin: 10px 0 0;
  resize: none;
  padding: 10px;
  color: #000;
}

.job-desc h4 {
  font-size: 22px;
  font-weight: 600;
}
.resume-build.personalize-resume {
  max-width: 300px;
  margin: 40px auto 0;
  justify-content: center;
  gap: 20px;
}
.resume-builder-main
  .resume-builder-right
  .content
  .resume-build.personalize-resume
  .resume-block {
  min-width: 100px;
  max-width: 100px;
  width: 100%;
  height: auto;
  padding: 20px;
  margin: 0;
}
.resume-build.personalize-resume > div {
  width: auto !important;
  max-width: inherit !important;
}
.skn-srz5 .address {
  font-size: 15px;
}
.resume-template > div > div {
  transform: scale(0.43);
  transform-origin: 0 0;
}
.resume-template > div > div #resumesec {
  width: 740px;
}
.template-preview .resume-template {
  height: 420px;
  overflow: hidden;
  margin-bottom: 10px;
  border: 1px solid #ddd;
}
.template-preview .resume-template .img-box img {
  width: 80px !important;
  height: 80px !important;
}
.template-preview .btn-select-template a.primary-btn.preview {
  display: flex;
  align-items: center;
  width: auto;
  padding: 4px 12px;
  text-align: center;
  justify-content: center;
  margin-bottom: 5px;
  position: absolute;
  bottom: 50px;
  font-size: 12px;
  border-radius: 30px;
  right: 10px;
  min-width: inherit;
}
.template-preview .btn-select-template select.form-control {
  height: auto;
}
.template-preview .btn-select-template a.primary-btn.preview i {
  margin-right: 5px;
  font-size: 16px;
}
div#resumesec .resume-block span {
  color: #000;
}
.modal-check-changes.modal-container.modal-width800 {
  max-width: 800px;
  width: 800px;
  padding: 20px;
}
.modal-check-changes .table-bordered thead th {
  border-bottom-width: 1px;
  background: #f1f1f1;
}
.modal-check-changes .table td,
.modal-check-changes .table-bordered th {
  width: 50%;
}
.modal-check-changes .modal-header button.close {
  padding: 0;
  margin: 0;
  position: absolute;
  right: 7px;
  top: 5px;
  font-size: 28px;
  opacity: 1;
  z-index: 9;
}
.enter-jd-job {
  max-width: 900px !important;
  width: 100%;
  margin: 50px auto 0;
  background: #f1f1f1;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #ddd;
}
.enter-jd-job .job-desc {
  max-width: 900px;
  margin: 10px auto;
  width: 100%;
}
.enter-jd-job .job-desc textarea {
  width: 100%;
  max-height: 400px;
  height: 100% !important;
  min-height: 300px;
  margin: 10px 0 0;
  resize: none;
  padding: 10px;
  color: #000;
}

.resume-builder-main .resume-builder-right.resume-preview {
  min-height: 100vh;
  padding: 30px;
  border-left: none;
  margin-left: 200px;
}
.previewTop {
  background: #f6f8f7;
  padding: 20px 30px;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
}

.previewTop > div {
  display: inline-block;
}

.previewTop .resume-edit a {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #1f85cd;
  font-size: 16px;
}

.resume-edit a img {
  margin-left: 10px;
}
.resume-preview-section > div {
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  padding: 10px;
  background: #fff;
  border-radius: 5px;
}
ul.bottom-preview-btn {
  display: flex;
  margin: 0 15px;
}
.resume-builder-main .resume-builder-right.resume-preview .btn-sec a {
  min-width: 150px;
}
.resume-builder-main .resume-builder-right .btn-sec .bottom-preview-btn a {
  display: flex;
  text-align: center;
  color: #000;
  font-size: 13px;
  line-height: 18px;
  max-width: 200px;
  background: transparent;
  border-radius: 5px;
  border: 1px solid transparent;
  min-height: 80px;
  padding: 5px;
  min-width: 110px;
  flex-wrap: wrap;
  align-items: center;
  cursor: pointer;
}
ul.bottom-preview-btn li a span {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.resume-builder-main .resume-builder-right .btn-sec .bottom-preview-btn li {
  border-left: 1px solid #919090;
  padding: 0 5px;
}
.resume-builder-main
  .resume-builder-right
  .btn-sec
  .bottom-preview-btn
  li:last-child {
  border-right: 1px solid #919090;
}
.resume-builder-main
  .resume-builder-right
  .btn-sec
  .bottom-preview-btn
  a:hover {
  background: #f1f1f1;
  border: 1px solid #d9d9d9;
  color: #1f85cd;
}
.resume-builder-main .resume-builder-right.resume-preview .btn-sec {
  padding: 15px 30px;
}
.choose-template-sec {
  background: rgba(0, 0, 0, 0.7);
  padding: 25px 30px;
  position: fixed;
  bottom: 113px;
  width: calc(100% - 200px);
  z-index: 1;
  left: 200px;
}
.choose-template-sec .owl-carousel .owl-item img {
  border: 2px solid transparent;
  transition: all 0.5s;
  cursor: pointer;
  height: 230px;
  object-fit: cover;
  object-position: top;
}
.choose-template-sec .owl-carousel .owl-item img:hover,
.choose-template-sec .owl-carousel .owl-item .active img {
  border: 2px solid #1f85cd;
  transition: all 0.5s;
}
.choose-template-sec .owl-nav {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  width: 100%;
  margin-top: -20px;
}
.choose-template-sec .owl-carousel .owl-nav .owl-next,
.choose-template-sec .owl-carousel .owl-nav .owl-prev {
  background: #1f85cd !important;
  color: #fff !important;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  text-indent: -9999px;
  font: normal normal normal 14px/1 FontAwesome;
}
.choose-template-sec .owl-carousel .owl-nav .owl-next:before {
  content: "\f105";
  text-indent: 0;
}
.choose-template-sec .owl-carousel .owl-nav .owl-prev:before {
  content: "\f104";
  text-indent: 0;
}
.choose-template-sec .owl-nav .owl-prev {
  left: -20px;
}

.choose-template-sec .owl-nav .owl-next {
  right: -20px;
}

.choose-template-sec .owl-theme .owl-dots {
  display: none;
}
span.material-icons.popupclose {
  position: absolute;
  color: #fff;
  right: 5px;
  top: 5px;
  font-size: 18px;
  cursor: pointer;
}
.resume-btn-sec a {
  margin-right: 15px;
}
.btn-primary.md-ink-ripple:hover {
  background: #1f85cd;
  color: #1f85cd;
}

.imgPreview .modal-content {
  border-radius: 11px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.18);
}
.imgPreview .modal-body {
  padding: 30px;
}
.imgPreview div#resumesec {
  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 0.18);
}
.imgPreview .modal-header h3 {
  margin: 0 !important;
}
.imgPreview .modal-header .close {
  padding: 0;
  margin: 3px 0 0;
  font-size: 30px;
  font-weight: normal;
  opacity: 1;
}
.imgPreview .modal-header {
  padding: 10px 30px;
  border-bottom: 1px solid #999;
}
.imgpreview .modal-dialog.modal-lg {
  max-width: 900px;
}
.headingSection {
  display: flex;
}
.headingSection .uploadSection {
  width: 120px;
  margin-right: 30px;
}
.headingSection .headingContent {
  width: calc(100% - 150px);
}
.resume-builder-main
  .resume-builder-right
  .content.skills-page
  .form-section
  > div {
  width: 100%;
}

/*************************New css for left panel*****************************/

.top-header .logo img {
  max-width: 150px;
}
.resume-builder-main .resume-builder-left {
  padding: 10px 20px;
  background: #1f85cd;
  color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 200px;
  z-index: 99;
  height: 100%;
  overflow: auto;
  transition: all 0.5s;
}
.resume-builder-main .resume-builder-left h3 {
  display: none;
}
.resume-builder-main .resume-builder-left .resume-section ul {
  margin-top: 20px;
  position: relative;
  padding-left: 0;
}
.resume-builder-main .resume-builder-left .resume-section ul:after,
.resume-builder-main .resume-builder-left .resume-section ul:before {
  display: none;
}
.resume-builder-main .resume-builder-left .resume-section ul li {
  position: relative;
  padding-bottom: 25px;
  padding-left: 35px;
  counter-increment: item;
  cursor: pointer;
}
.resume-builder-main .resume-builder-left .resume-section ul li:before {
  top: -2px;
  width: 24px;
  height: 24px;
  border: 2px solid #fff;
  margin: 0;
  left: 0;
  position: absolute;
  z-index: 1;
  background: #fff;
  border-color: #fff;
  color: #000;
  content: "";
  font: normal normal normal 14px/1 "FontAwesome";
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.resume-builder-main .resume-builder-left .resume-section ul li a {
  color: #fff;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  padding: 0;
}
.resume-builder-main .resume-builder-left .resume-section ul li a:before {
  left: -22px;
  top: 8px;
  width: 27px;
  height: 100%;
  transform: rotate(90deg);
  z-index: 0;
  border-top: 2px solid #fff;
  content: "";
  position: absolute;
}
.resume-builder-main .resume-builder-left .resume-section ul li a span {
  display: none;
}
.resume-builder-main .resume-builder-left .resume-section ul li.active:before {
  color: #07142b;
  font-weight: 700;
  border: 4px solid #a7c4eb;
  width: 30px;
  height: 30px;
  line-height: 30px;
  left: -3px;
  top: -5px;
  background: #fff;
  content: counter(item);
  font-family: "Montserrat", sans-serif;
}
.resume-builder-main .resume-builder-left .resume-section ul li.active a {
  color: #fff;
  font-weight: 700;
}
.resume-builder-main
  .resume-builder-left
  .resume-section
  ul
  li:last-child
  a:before {
  display: none;
}

.resume-builder-main .resume-builder-right {
  padding: 30px 30px 30px 230px;
}
.resume-builder-main .resume-builder-right .btn-sec {
  max-width: calc(100% - 200px);
  left: 200px;
  padding: 15px 30px;
}

.resume-builder-main .resume-builder-right .content .form-section .right-form {
  min-width: 320px;
  max-width: 320px;
}
.upload-img label.btn-secondary {
  font-size: 14px;
  padding: 12px 10px;
  text-align: center;
  margin: 20px auto 0;
  display: block;
  max-width: 130px;
  line-height: normal;
  width: 100%;
  min-width: inherit;
  cursor: pointer;
}
#ChnageTemplate .modal-dialog {
            max-width: 1138px;
        }

        #ChnageTemplate .modal-content {
            box-shadow: 0 0 20px 0 rgba(0,0,0,0.18);
            border-radius: 11px;
        }

        #ChnageTemplate .modal-header {
            border-bottom: 1px solid #ccc6bf;
        }

            #ChnageTemplate .modal-header h5 {
                color: #000;
                font-size: 22px;
                font-weight: 600;
            }

            #ChnageTemplate .modal-header button.close {
                opacity: 1;
                font-weight: normal;
                color: #000;
                font-size: 32px;
            }

        #ChnageTemplate .modal-body {
            padding: 0;
        }

        .ResumePreview {
            max-height: calc(100vh - 80px);
            background: #ecf2f9;
            padding: 44px 55px;
            overflow-y: scroll;
            border-bottom-left-radius: 11px;
        }

        .TemplateSelector .ColorPanel {
            padding: 30px 35px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
        }

            .TemplateSelector .ColorPanel span.color-panel-title {
                font-weight: 600;
                color: #000;
                font-size: 14px;
                margin-right: 7px;
            }

        ul.color-selector {
            display: flex;
            align-items: center;
            gap: 3px;
        }

            ul.color-selector li {
                position: relative;
                padding: 2px;
                z-index: 9;
            
            }

                ul.color-selector li label {
                    cursor: pointer;
                    display: block;
                    margin: 0 auto;
                    width: 30px;
                    height: 30px;
                    position: relative;
                    border: 2px solid rgba(0,0,0,0);
                    border-radius: 50px;
                    padding: 2px;
                    transition: all 0.3s;
                }

                    ul.color-selector li label:hover {
                        width: 30px;
                        height: 30px;
                        padding: 1px;
                    }

        .color-selector li label.active {
            border-color: #808d97;
        }

        .color-selector .color-selector-radio {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 50px;
            position: relative;
            text-align: center;
        }

        .color-selector input[type="radio"] {
            width: 100%;
            height: 100%;
            opacity: 0;
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }

        ul.color-dropdown {
            background-color: #fff;
            box-shadow: 0 3px 5px 0 rgba(0,0,0,0.2);
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0%);
            border-radius: 0 0 8px 8px;
            display: none;
        }

        ul.color-selector > li:hover {
            box-shadow: 0 3px 5px 0 rgba(0,0,0,0.2);
            border-radius: 8px 8px 0 0;
            height: 100%;
        }

        ul.color-selector li:hover ul.color-dropdown {
            display: block;
        }

        .color-selector-reset .color-selector-radio {
            border: 1px solid #ddd;
            background-color: #fff;
        }

        ul.color-selector li label.color-selector-reset {
            width: 32px;
            height: 32px;
            padding: 1px;
        }

        .ResumePanel {
            max-height: calc(100vh - 269px);
            overflow-y: scroll;
            display: flex;
            flex-wrap: wrap;
            background: #2e2e2e;
            padding: 20px 34px;
        }

        .ResumeBottomPanel {
            display: flex;
            justify-content: space-between;
            padding: 15px;
        }

            .ResumeBottomPanel .primary-btn {
                background: #1f85cd;
                border-color: #1f85cd;
                font-size: 15px;
                border-radius: 30px;
                padding: 10px 30px;
                color: #fff;
                cursor: pointer;
                font-weight: 500;
            }

                .ResumeBottomPanel .primary-btn:hover {
                    background: #fff;
                    color: #1f85cd;
                }

            .ResumeBottomPanel .secondary-btn {
                border-color: #1f85cd;
                color: #1f85cd;
                font-size: 15px;
                border-radius: 30px;
                padding: 10px 30px;
                font-weight: 500;
                cursor: pointer;
            }

                .ResumeBottomPanel .secondary-btn:hover {
                    background: #1f85cd;
                    color: #fff;
                }
        .ResumeFullPreview > div {
            transform: scale(0.87);
            min-width: 595px;
            transform-origin: 0 0;
            box-shadow: 0 0 17px 0 rgba(0,0,0,0.18);
            background:#fff;
        }
        .ResumePanel .ThumbPreview {
            width: 182px;
            margin: 7px 4.5px;
            background: #fff;
            overflow: hidden;
            border: 4px solid #2e2e2e;
            height: 210px;
            cursor:pointer;
        }
            .ResumePanel .ThumbPreview:hover, .ResumePanel .ThumbPreview.active {
                border-color: #1f85cd;
            }
            .ResumePanel .ThumbPreview > div {
                transform: scale(0.295);
                transform-origin: 0 0;
                width: 595px;
            }
        .heading-strip {
            filter: brightness(0.8);
        }
</style>